export const baseColors = {
  neutral_50: '#fcfcfc',
  neutral_50_5: '#fcfcfc0D',
  neutral_50_10: '#fcfcfc19',
  neutral_50_20: '#fcfcfc33',
  neutral_50_30: '#fcfcfc4D',
  neutral_50_40: '#fcfcfc66',
  neutral_50_50: '#fcfcfc80',
  neutral_50_65: '#fcfcfcA5',
  neutral_50_75: '#fcfcfcBF',
  neutral_50_80: '#fcfcfcCC',
  neutral_50_90: '#fcfcfcE6',
  neutral_100: '#f5f5f5',
  neutral_100_5: '#f5f5f50D',
  neutral_100_10: '#f5f5f519',
  neutral_100_20: '#f5f5f533',
  neutral_100_30: '#f5f5f54D',
  neutral_100_40: '#f5f5f566',
  neutral_100_50: '#f5f5f580',
  neutral_100_65: '#f5f5f5A5',
  neutral_100_75: '#f5f5f5BF',
  neutral_100_80: '#f5f5f5CC',
  neutral_100_90: '#f5f5f5E6',
  neutral_200: '#e5e5e5',
  neutral_200_5: '#e5e5e50D',
  neutral_200_10: '#e5e5e519',
  neutral_200_20: '#e5e5e533',
  neutral_200_30: '#e5e5e54D',
  neutral_200_40: '#e5e5e566',
  neutral_200_50: '#e5e5e580',
  neutral_200_65: '#e5e5e5A5',
  neutral_200_75: '#e5e5e5BF',
  neutral_200_80: '#e5e5e5CC',
  neutral_200_90: '#e5e5e5E6',
  neutral_300: '#d4d4d4',
  neutral_300_5: '#d4d4d40D',
  neutral_300_10: '#d4d4d419',
  neutral_300_20: '#d4d4d433',
  neutral_300_30: '#d4d4d44D',
  neutral_300_40: '#d4d4d466',
  neutral_300_50: '#d4d4d480',
  neutral_300_65: '#d4d4d4A5',
  neutral_300_75: '#d4d4d4BF',
  neutral_300_80: '#d4d4d4CC',
  neutral_300_90: '#d4d4d4E6',
  neutral_400: '#a5a5a5',
  neutral_400_5: '#a5a5a50D',
  neutral_400_10: '#a5a5a519',
  neutral_400_20: '#a5a5a533',
  neutral_400_30: '#a5a5a54D',
  neutral_400_40: '#a5a5a566',
  neutral_400_50: '#a5a5a580',
  neutral_400_65: '#a5a5a5A5',
  neutral_400_75: '#a5a5a5BF',
  neutral_400_80: '#a5a5a5CC',
  neutral_400_90: '#a5a5a5E6',
  neutral_500: '#757575',
  neutral_500_5: '#7575750D',
  neutral_500_10: '#75757519',
  neutral_500_20: '#75757533',
  neutral_500_30: '#7575754D',
  neutral_500_40: '#75757566',
  neutral_500_50: '#75757580',
  neutral_500_65: '#757575A5',
  neutral_500_75: '#757575BF',
  neutral_500_80: '#757575CC',
  neutral_500_90: '#757575E6',
  neutral_600: '#535353',
  neutral_600_5: '#5353530D',
  neutral_600_10: '#53535319',
  neutral_600_20: '#53535333',
  neutral_600_30: '#5353534D',
  neutral_600_40: '#53535366',
  neutral_600_50: '#53535380',
  neutral_600_65: '#535353A5',
  neutral_600_75: '#535353BF',
  neutral_600_80: '#535353CC',
  neutral_600_90: '#535353E6',
  neutral_700: '#404040',
  neutral_700_5: '#4040400D',
  neutral_700_10: '#40404019',
  neutral_700_20: '#40404033',
  neutral_700_30: '#4040404D',
  neutral_700_40: '#40404066',
  neutral_700_50: '#40404080',
  neutral_700_65: '#404040A5',
  neutral_700_75: '#404040BF',
  neutral_700_80: '#404040CC',
  neutral_700_90: '#404040E6',
  neutral_800: '#262626',
  neutral_800_5: '#2626260D',
  neutral_800_10: '#26262619',
  neutral_800_20: '#26262633',
  neutral_800_30: '#2626264D',
  neutral_800_40: '#26262666',
  neutral_800_50: '#26262680',
  neutral_800_65: '#262626A5',
  neutral_800_75: '#262626BF',
  neutral_800_80: '#262626CC',
  neutral_800_90: '#262626E6',
  neutral_900: '#161616',
  neutral_900_5: '#1616160D',
  neutral_900_10: '#16161619',
  neutral_900_20: '#16161633',
  neutral_900_30: '#1616164D',
  neutral_900_40: '#16161666',
  neutral_900_50: '#16161680',
  neutral_900_65: '#161616A5',
  neutral_900_75: '#161616BF',
  neutral_900_80: '#161616CC',
  neutral_900_90: '#161616E6',
  neutral_950: '#090909',
  neutral_950_5: '#0909090D',
  neutral_950_10: '#09090919',
  neutral_950_20: '#09090933',
  neutral_950_30: '#0909094D',
  neutral_950_40: '#09090966',
  neutral_950_50: '#09090980',
  neutral_950_65: '#090909A5',
  neutral_950_75: '#090909BF',
  neutral_950_80: '#090909CC',
  neutral_950_90: '#090909E6',

  black_700: '#29292a',
  black_700_5: '#29292a0D',
  black_700_10: '#29292a19',
  black_700_20: '#29292a33',
  black_700_30: '#29292a4D',
  black_700_40: '#29292a66',
  black_700_50: '#29292a80',
  black_700_65: '#29292aA5',
  black_700_75: '#29292aBF',
  black_700_80: '#29292aCC',
  black_700_90: '#29292aE6',
  black_800: '#1e1e1f',
  black_800_5: '#1e1e1f0D',
  black_800_10: '#1e1e1f19',
  black_800_20: '#1e1e1f33',
  black_800_30: '#1e1e1f4D',
  black_800_40: '#1e1e1f66',
  black_800_50: '#1e1e1f80',
  black_800_65: '#1e1e1fA5',
  black_800_75: '#1e1e1fBF',
  black_800_80: '#1e1e1fCC',
  black_800_90: '#1e1e1fE6',
  black_900: '#141414',
  black_900_5: '#1414140D',
  black_900_10: '#14141419',
  black_900_20: '#14141433',
  black_900_30: '#1414144D',
  black_900_40: '#14141466',
  black_900_50: '#14141480',
  black_900_65: '#141414A5',
  black_900_75: '#141414BF',
  black_900_80: '#141414CC',
  black_900_90: '#141414E6',
  black_950: '#131313',
  black_950_5: '#1313130D',
  black_950_10: '#13131319',
  black_950_20: '#13131333',
  black_950_30: '#1313134D',
  black_950_40: '#13131366',
  black_950_50: '#13131380',
  black_950_65: '#131313A5',
  black_950_75: '#131313BF',
  black_950_80: '#131313CC',
  black_950_90: '#131313E6',
  black_1000: '#000000',
  black_1000_5: '#0000000D',
  black_1000_10: '#00000019',
  black_1000_20: '#00000033',
  black_1000_30: '#0000004D',
  black_1000_40: '#00000066',
  black_1000_50: '#00000080',
  black_1000_65: '#000000A5',
  black_1000_75: '#000000BF',
  black_1000_80: '#000000CC',
  black_1000_90: '#000000E6',

  stone_50: '#f9f9f9',
  stone_50_5: '#f9f9f90D',
  stone_50_10: '#f9f9f919',
  stone_50_20: '#f9f9f933',
  stone_50_30: '#f9f9f94D',
  stone_50_40: '#f9f9f966',
  stone_50_50: '#f9f9f980',
  stone_50_65: '#f9f9f9A5',
  stone_50_75: '#f9f9f9BF',
  stone_50_80: '#f9f9f9CC',
  stone_50_90: '#f9f9f9E6',
  stone_100: '#f5f5f5',
  stone_100_5: '#f5f5f50D',
  stone_100_10: '#f5f5f519',
  stone_100_20: '#f5f5f533',
  stone_100_30: '#f5f5f54D',
  stone_100_40: '#f5f5f566',
  stone_100_50: '#f5f5f580',
  stone_100_65: '#f5f5f5A5',
  stone_100_75: '#f5f5f5BF',
  stone_100_80: '#f5f5f5CC',
  stone_100_90: '#f5f5f5E6',
  stone_200: '#e5e5e5',
  stone_200_5: '#e5e5e50D',
  stone_200_10: '#e5e5e519',
  stone_200_20: '#e5e5e533',
  stone_200_30: '#e5e5e54D',
  stone_200_40: '#e5e5e566',
  stone_200_50: '#e5e5e580',
  stone_200_65: '#e5e5e5A5',
  stone_200_75: '#e5e5e5BF',
  stone_200_80: '#e5e5e5CC',
  stone_200_90: '#e5e5e5E6',
  stone_300: '#d4d4d4',
  stone_300_5: '#d4d4d40D',
  stone_300_10: '#d4d4d419',
  stone_300_20: '#d4d4d433',
  stone_300_30: '#d4d4d44D',
  stone_300_40: '#d4d4d466',
  stone_300_50: '#d4d4d480',
  stone_300_65: '#d4d4d4A5',
  stone_300_75: '#d4d4d4BF',
  stone_300_80: '#d4d4d4CC',
  stone_300_90: '#d4d4d4E6',
  stone_400: '#aaa49e',
  stone_400_5: '#aaa49e0D',
  stone_400_10: '#aaa49e19',
  stone_400_20: '#aaa49e33',
  stone_400_30: '#aaa49e4D',
  stone_400_40: '#aaa49e66',
  stone_400_50: '#aaa49e80',
  stone_400_65: '#aaa49eA5',
  stone_400_75: '#aaa49eBF',
  stone_400_80: '#aaa49eCC',
  stone_400_90: '#aaa49eE6',
  stone_500: '#76716d',
  stone_500_5: '#76716d0D',
  stone_500_10: '#76716d19',
  stone_500_20: '#76716d33',
  stone_500_30: '#76716d4D',
  stone_500_40: '#76716d66',
  stone_500_50: '#76716d80',
  stone_500_65: '#76716dA5',
  stone_500_75: '#76716dBF',
  stone_500_80: '#76716dCC',
  stone_500_90: '#76716dE6',
  stone_600: '#56524c',
  stone_600_5: '#56524c0D',
  stone_600_10: '#56524c19',
  stone_600_20: '#56524c33',
  stone_600_30: '#56524c4D',
  stone_600_40: '#56524c66',
  stone_600_50: '#56524c80',
  stone_600_65: '#56524cA5',
  stone_600_75: '#56524cBF',
  stone_600_80: '#56524cCC',
  stone_600_90: '#56524cE6',
  stone_700: '#443f3b',
  stone_700_5: '#443f3b0D',
  stone_700_10: '#443f3b19',
  stone_700_20: '#443f3b33',
  stone_700_30: '#443f3b4D',
  stone_700_40: '#443f3b66',
  stone_700_50: '#443f3b80',
  stone_700_65: '#443f3bA5',
  stone_700_75: '#443f3bBF',
  stone_700_80: '#443f3bCC',
  stone_700_90: '#443f3bE6',
  stone_800: '#2b2524',
  stone_800_5: '#2b25240D',
  stone_800_10: '#2b252419',
  stone_800_20: '#2b252433',
  stone_800_30: '#2b25244D',
  stone_800_40: '#2b252466',
  stone_800_50: '#2b252480',
  stone_800_65: '#2b2524A5',
  stone_800_75: '#2b2524BF',
  stone_800_80: '#2b2524CC',
  stone_800_90: '#2b2524E6',
  stone_900: '#1f1a17',
  stone_900_5: '#1f1a170D',
  stone_900_10: '#1f1a1719',
  stone_900_20: '#1f1a1733',
  stone_900_30: '#1f1a174D',
  stone_900_40: '#1f1a1766',
  stone_900_50: '#1f1a1780',
  stone_900_65: '#1f1a17A5',
  stone_900_75: '#1f1a17BF',
  stone_900_80: '#1f1a17CC',
  stone_900_90: '#1f1a17E6',
  stone_950: '#0b0b0b',
  stone_950_5: '#0b0b0b0D',
  stone_950_10: '#0b0b0b19',
  stone_950_20: '#0b0b0b33',
  stone_950_30: '#0b0b0b4D',
  stone_950_40: '#0b0b0b66',
  stone_950_50: '#0b0b0b80',
  stone_950_65: '#0b0b0bA5',
  stone_950_75: '#0b0b0bBF',
  stone_950_80: '#0b0b0bCC',
  stone_950_90: '#0b0b0bE6',

  zinc_50: '#fcfcfc',
  zinc_50_5: '#fcfcfc0D',
  zinc_50_10: '#fcfcfc19',
  zinc_50_20: '#fcfcfc33',
  zinc_50_30: '#fcfcfc4D',
  zinc_50_40: '#fcfcfc66',
  zinc_50_50: '#fcfcfc80',
  zinc_50_65: '#fcfcfcA5',
  zinc_50_75: '#fcfcfcBF',
  zinc_50_80: '#fcfcfcCC',
  zinc_50_90: '#fcfcfcE6',
  zinc_100: '#f5f5f5',
  zinc_100_5: '#f5f5f50D',
  zinc_100_10: '#f5f5f519',
  zinc_100_20: '#f5f5f533',
  zinc_100_30: '#f5f5f54D',
  zinc_100_40: '#f5f5f566',
  zinc_100_50: '#f5f5f580',
  zinc_100_65: '#f5f5f5A5',
  zinc_100_75: '#f5f5f5BF',
  zinc_100_80: '#f5f5f5CC',
  zinc_100_90: '#f5f5f5E6',
  zinc_200: '#e5e5e5',
  zinc_200_5: '#e5e5e50D',
  zinc_200_10: '#e5e5e519',
  zinc_200_20: '#e5e5e533',
  zinc_200_30: '#e5e5e54D',
  zinc_200_40: '#e5e5e566',
  zinc_200_50: '#e5e5e580',
  zinc_200_65: '#e5e5e5A5',
  zinc_200_75: '#e5e5e5BF',
  zinc_200_80: '#e5e5e5CC',
  zinc_200_90: '#e5e5e5E6',
  zinc_300: '#d4d4db',
  zinc_300_5: '#d4d4db0D',
  zinc_300_10: '#d4d4db19',
  zinc_300_20: '#d4d4db33',
  zinc_300_30: '#d4d4db4D',
  zinc_300_40: '#d4d4db66',
  zinc_300_50: '#d4d4db80',
  zinc_300_65: '#d4d4dbA5',
  zinc_300_75: '#d4d4dbBF',
  zinc_300_80: '#d4d4dbCC',
  zinc_300_90: '#d4d4dbE6',
  zinc_400: '#a1a1a8',
  zinc_400_5: '#a1a1a80D',
  zinc_400_10: '#a1a1a819',
  zinc_400_20: '#a1a1a833',
  zinc_400_30: '#a1a1a84D',
  zinc_400_40: '#a1a1a866',
  zinc_400_50: '#a1a1a880',
  zinc_400_65: '#a1a1a8A5',
  zinc_400_75: '#a1a1a8BF',
  zinc_400_80: '#a1a1a8CC',
  zinc_400_90: '#a1a1a8E6',
  zinc_500: '#717178',
  zinc_500_5: '#7171780D',
  zinc_500_10: '#71717819',
  zinc_500_20: '#71717833',
  zinc_500_30: '#7171784D',
  zinc_500_40: '#71717866',
  zinc_500_50: '#71717880',
  zinc_500_65: '#717178A5',
  zinc_500_75: '#717178BF',
  zinc_500_80: '#717178CC',
  zinc_500_90: '#717178E6',
  zinc_600: '#525259',
  zinc_600_5: '#5252590D',
  zinc_600_10: '#52525919',
  zinc_600_20: '#52525933',
  zinc_600_30: '#5252594D',
  zinc_600_40: '#52525966',
  zinc_600_50: '#52525980',
  zinc_600_65: '#525259A5',
  zinc_600_75: '#525259BF',
  zinc_600_80: '#525259CC',
  zinc_600_90: '#525259E6',
  zinc_700: '#3f3f46',
  zinc_700_5: '#3f3f460D',
  zinc_700_10: '#3f3f4619',
  zinc_700_20: '#3f3f4633',
  zinc_700_30: '#3f3f464D',
  zinc_700_40: '#3f3f4666',
  zinc_700_50: '#3f3f4680',
  zinc_700_65: '#3f3f46A5',
  zinc_700_75: '#3f3f46BF',
  zinc_700_80: '#3f3f46CC',
  zinc_700_90: '#3f3f46E6',
  zinc_800: '#26262b',
  zinc_800_5: '#26262b0D',
  zinc_800_10: '#26262b19',
  zinc_800_20: '#26262b33',
  zinc_800_30: '#26262b4D',
  zinc_800_40: '#26262b66',
  zinc_800_50: '#26262b80',
  zinc_800_65: '#26262bA5',
  zinc_800_75: '#26262bBF',
  zinc_800_80: '#26262bCC',
  zinc_800_90: '#26262bE6',
  zinc_900: '#18181c',
  zinc_900_5: '#18181c0D',
  zinc_900_10: '#18181c19',
  zinc_900_20: '#18181c33',
  zinc_900_30: '#18181c4D',
  zinc_900_40: '#18181c66',
  zinc_900_50: '#18181c80',
  zinc_900_65: '#18181cA5',
  zinc_900_75: '#18181cBF',
  zinc_900_80: '#18181cCC',
  zinc_900_90: '#18181cE6',
  zinc_950: '#090909',
  zinc_950_5: '#0909090D',
  zinc_950_10: '#09090919',
  zinc_950_20: '#09090933',
  zinc_950_30: '#0909094D',
  zinc_950_40: '#09090966',
  zinc_950_50: '#09090980',
  zinc_950_65: '#090909A5',
  zinc_950_75: '#090909BF',
  zinc_950_80: '#090909CC',
  zinc_950_90: '#090909E6',

  slate_50: '#f9f9f9',
  slate_50_5: '#f9f9f90D',
  slate_50_10: '#f9f9f919',
  slate_50_20: '#f9f9f933',
  slate_50_30: '#f9f9f94D',
  slate_50_40: '#f9f9f966',
  slate_50_50: '#f9f9f980',
  slate_50_65: '#f9f9f9A5',
  slate_50_75: '#f9f9f9BF',
  slate_50_80: '#f9f9f9CC',
  slate_50_90: '#f9f9f9E6',
  slate_100: '#f0f6fc',
  slate_100_5: '#f0f6fc0D',
  slate_100_10: '#f0f6fc19',
  slate_100_20: '#f0f6fc33',
  slate_100_30: '#f0f6fc4D',
  slate_100_40: '#f0f6fc66',
  slate_100_50: '#f0f6fc80',
  slate_100_65: '#f0f6fcA5',
  slate_100_75: '#f0f6fcBF',
  slate_100_80: '#f0f6fcCC',
  slate_100_90: '#f0f6fcE6',
  slate_200: '#e4e8ef',
  slate_200_5: '#e4e8ef0D',
  slate_200_10: '#e4e8ef19',
  slate_200_20: '#e4e8ef33',
  slate_200_30: '#e4e8ef4D',
  slate_200_40: '#e4e8ef66',
  slate_200_50: '#e4e8ef80',
  slate_200_65: '#e4e8efA5',
  slate_200_75: '#e4e8efBF',
  slate_200_80: '#e4e8efCC',
  slate_200_90: '#e4e8efE6',
  slate_300: '#cbd5e1',
  slate_300_5: '#cbd5e10D',
  slate_300_10: '#cbd5e119',
  slate_300_20: '#cbd5e133',
  slate_300_30: '#cbd5e14D',
  slate_300_40: '#cbd5e166',
  slate_300_50: '#cbd5e180',
  slate_300_65: '#cbd5e1A5',
  slate_300_75: '#cbd5e1BF',
  slate_300_80: '#cbd5e1CC',
  slate_300_90: '#cbd5e1E6',
  slate_400: '#92a4bb',
  slate_400_5: '#92a4bb0D',
  slate_400_10: '#92a4bb19',
  slate_400_20: '#92a4bb33',
  slate_400_30: '#92a4bb4D',
  slate_400_40: '#92a4bb66',
  slate_400_50: '#92a4bb80',
  slate_400_65: '#92a4bbA5',
  slate_400_75: '#92a4bbBF',
  slate_400_80: '#92a4bbCC',
  slate_400_90: '#92a4bbE6',
  slate_500: '#637489',
  slate_500_5: '#6374890D',
  slate_500_10: '#63748919',
  slate_500_20: '#63748933',
  slate_500_30: '#6374894D',
  slate_500_40: '#63748966',
  slate_500_50: '#63748980',
  slate_500_65: '#637489A5',
  slate_500_75: '#637489BF',
  slate_500_80: '#637489CC',
  slate_500_90: '#637489E6',
  slate_600: '#47566c',
  slate_600_5: '#47566c0D',
  slate_600_10: '#47566c19',
  slate_600_20: '#47566c33',
  slate_600_30: '#47566c4D',
  slate_600_40: '#47566c66',
  slate_600_50: '#47566c80',
  slate_600_65: '#47566cA5',
  slate_600_75: '#47566cBF',
  slate_600_80: '#47566cCC',
  slate_600_90: '#47566cE6',
  slate_700: '#324055',
  slate_700_5: '#3240550D',
  slate_700_10: '#32405519',
  slate_700_20: '#32405533',
  slate_700_30: '#3240554D',
  slate_700_40: '#32405566',
  slate_700_50: '#32405580',
  slate_700_65: '#324055A5',
  slate_700_75: '#324055BF',
  slate_700_80: '#324055CC',
  slate_700_90: '#324055E6',
  slate_800: '#1e293d',
  slate_800_5: '#1e293d0D',
  slate_800_10: '#1e293d19',
  slate_800_20: '#1e293d33',
  slate_800_30: '#1e293d4D',
  slate_800_40: '#1e293d66',
  slate_800_50: '#1e293d80',
  slate_800_65: '#1e293dA5',
  slate_800_75: '#1e293dBF',
  slate_800_80: '#1e293dCC',
  slate_800_90: '#1e293dE6',
  slate_900: '#0f172a',
  slate_900_5: '#0f172a0D',
  slate_900_10: '#0f172a19',
  slate_900_20: '#0f172a33',
  slate_900_30: '#0f172a4D',
  slate_900_40: '#0f172a66',
  slate_900_50: '#0f172a80',
  slate_900_65: '#0f172aA5',
  slate_900_75: '#0f172aBF',
  slate_900_80: '#0f172aCC',
  slate_900_90: '#0f172aE6',
  slate_950: '#020617',
  slate_950_5: '#0206170D',
  slate_950_10: '#02061719',
  slate_950_20: '#02061733',
  slate_950_30: '#0206174D',
  slate_950_40: '#02061766',
  slate_950_50: '#02061780',
  slate_950_65: '#020617A5',
  slate_950_75: '#020617BF',
  slate_950_80: '#020617CC',
  slate_950_90: '#020617E6',

  gray_50: '#f9f9f9',
  gray_50_5: '#f9f9f90D',
  gray_50_10: '#f9f9f919',
  gray_50_20: '#f9f9f933',
  gray_50_30: '#f9f9f94D',
  gray_50_40: '#f9f9f966',
  gray_50_50: '#f9f9f980',
  gray_50_65: '#f9f9f9A5',
  gray_50_75: '#f9f9f9BF',
  gray_50_80: '#f9f9f9CC',
  gray_50_90: '#f9f9f9E6',
  gray_100: '#f5f5f5',
  gray_100_5: '#f5f5f50D',
  gray_100_10: '#f5f5f519',
  gray_100_20: '#f5f5f533',
  gray_100_30: '#f5f5f54D',
  gray_100_40: '#f5f5f566',
  gray_100_50: '#f5f5f580',
  gray_100_65: '#f5f5f5A5',
  gray_100_75: '#f5f5f5BF',
  gray_100_80: '#f5f5f5CC',
  gray_100_90: '#f5f5f5E6',
  gray_200: '#e4e8ef',
  gray_200_5: '#e4e8ef0D',
  gray_200_10: '#e4e8ef19',
  gray_200_20: '#e4e8ef33',
  gray_200_30: '#e4e8ef4D',
  gray_200_40: '#e4e8ef66',
  gray_200_50: '#e4e8ef80',
  gray_200_65: '#e4e8efA5',
  gray_200_75: '#e4e8efBF',
  gray_200_80: '#e4e8efCC',
  gray_200_90: '#e4e8efE6',
  gray_300: '#d0d5db',
  gray_300_5: '#d0d5db0D',
  gray_300_10: '#d0d5db19',
  gray_300_20: '#d0d5db33',
  gray_300_30: '#d0d5db4D',
  gray_300_40: '#d0d5db66',
  gray_300_50: '#d0d5db80',
  gray_300_65: '#d0d5dbA5',
  gray_300_75: '#d0d5dbBF',
  gray_300_80: '#d0d5dbCC',
  gray_300_90: '#d0d5dbE6',
  gray_400: '#9ba2ae',
  gray_400_5: '#9ba2ae0D',
  gray_400_10: '#9ba2ae19',
  gray_400_20: '#9ba2ae33',
  gray_400_30: '#9ba2ae4D',
  gray_400_40: '#9ba2ae66',
  gray_400_50: '#9ba2ae80',
  gray_400_65: '#9ba2aeA5',
  gray_400_75: '#9ba2aeBF',
  gray_400_80: '#9ba2aeCC',
  gray_400_90: '#9ba2aeE6',
  gray_500: '#6c727e',
  gray_500_5: '#6c727e0D',
  gray_500_10: '#6c727e19',
  gray_500_20: '#6c727e33',
  gray_500_30: '#6c727e4D',
  gray_500_40: '#6c727e66',
  gray_500_50: '#6c727e80',
  gray_500_65: '#6c727eA5',
  gray_500_75: '#6c727eBF',
  gray_500_80: '#6c727eCC',
  gray_500_90: '#6c727eE6',
  gray_600: '#4b5666',
  gray_600_5: '#4b56660D',
  gray_600_10: '#4b566619',
  gray_600_20: '#4b566633',
  gray_600_30: '#4b56664D',
  gray_600_40: '#4b566666',
  gray_600_50: '#4b566680',
  gray_600_65: '#4b5666A5',
  gray_600_75: '#4b5666BF',
  gray_600_80: '#4b5666CC',
  gray_600_90: '#4b5666E6',
  gray_700: '#374050',
  gray_700_5: '#3740500D',
  gray_700_10: '#37405019',
  gray_700_20: '#37405033',
  gray_700_30: '#3740504D',
  gray_700_40: '#37405066',
  gray_700_50: '#37405080',
  gray_700_65: '#374050A5',
  gray_700_75: '#374050BF',
  gray_700_80: '#374050CC',
  gray_700_90: '#374050E6',
  gray_800: '#1f2938',
  gray_800_5: '#1f29380D',
  gray_800_10: '#1f293819',
  gray_800_20: '#1f293833',
  gray_800_30: '#1f29384D',
  gray_800_40: '#1f293866',
  gray_800_50: '#1f293880',
  gray_800_65: '#1f2938A5',
  gray_800_75: '#1f2938BF',
  gray_800_80: '#1f2938CC',
  gray_800_90: '#1f2938E6',
  gray_900: '#121826',
  gray_900_5: '#1218260D',
  gray_900_10: '#12182619',
  gray_900_20: '#12182633',
  gray_900_30: '#1218264D',
  gray_900_40: '#12182666',
  gray_900_50: '#12182680',
  gray_900_65: '#121826A5',
  gray_900_75: '#121826BF',
  gray_900_80: '#121826CC',
  gray_900_90: '#121826E6',
  gray_950: '#020713',
  gray_950_5: '#0207130D',
  gray_950_10: '#02071319',
  gray_950_20: '#02071333',
  gray_950_30: '#0207134D',
  gray_950_40: '#02071366',
  gray_950_50: '#02071380',
  gray_950_65: '#020713A5',
  gray_950_75: '#020713BF',
  gray_950_80: '#020713CC',
  gray_950_90: '#020713E6',

  red_50: '#fcf3f3',
  red_50_5: '#fcf3f30D',
  red_50_10: '#fcf3f319',
  red_50_20: '#fcf3f333',
  red_50_30: '#fcf3f34D',
  red_50_40: '#fcf3f366',
  red_50_50: '#fcf3f380',
  red_50_65: '#fcf3f3A5',
  red_50_75: '#fcf3f3BF',
  red_50_80: '#fcf3f3CC',
  red_50_90: '#fcf3f3E6',
  red_100: '#ffe4e3',
  red_100_5: '#ffe4e30D',
  red_100_10: '#ffe4e319',
  red_100_20: '#ffe4e333',
  red_100_30: '#ffe4e34D',
  red_100_40: '#ffe4e366',
  red_100_50: '#ffe4e380',
  red_100_65: '#ffe4e3A5',
  red_100_75: '#ffe4e3BF',
  red_100_80: '#ffe4e3CC',
  red_100_90: '#ffe4e3E6',
  red_200: '#fdc9c9',
  red_200_5: '#fdc9c90D',
  red_200_10: '#fdc9c919',
  red_200_20: '#fdc9c933',
  red_200_30: '#fdc9c94D',
  red_200_40: '#fdc9c966',
  red_200_50: '#fdc9c980',
  red_200_65: '#fdc9c9A5',
  red_200_75: '#fdc9c9BF',
  red_200_80: '#fdc9c9CC',
  red_200_90: '#fdc9c9E6',
  red_300: '#fba7a6',
  red_300_5: '#fba7a60D',
  red_300_10: '#fba7a619',
  red_300_20: '#fba7a633',
  red_300_30: '#fba7a64D',
  red_300_40: '#fba7a666',
  red_300_50: '#fba7a680',
  red_300_65: '#fba7a6A5',
  red_300_75: '#fba7a6BF',
  red_300_80: '#fba7a6CC',
  red_300_90: '#fba7a6E6',
  red_400: '#fa7070',
  red_400_5: '#fa70700D',
  red_400_10: '#fa707019',
  red_400_20: '#fa707033',
  red_400_30: '#fa70704D',
  red_400_40: '#fa707066',
  red_400_50: '#fa707080',
  red_400_65: '#fa7070A5',
  red_400_75: '#fa7070BF',
  red_400_80: '#fa7070CC',
  red_400_90: '#fa7070E6',
  red_500: '#f24346',
  red_500_5: '#f243460D',
  red_500_10: '#f2434619',
  red_500_20: '#f2434633',
  red_500_30: '#f243464D',
  red_500_40: '#f2434666',
  red_500_50: '#f2434680',
  red_500_65: '#f24346A5',
  red_500_75: '#f24346BF',
  red_500_80: '#f24346CC',
  red_500_90: '#f24346E6',
  red_600: '#df2125',
  red_600_5: '#df21250D',
  red_600_10: '#df212519',
  red_600_20: '#df212533',
  red_600_30: '#df21254D',
  red_600_40: '#df212566',
  red_600_50: '#df212580',
  red_600_65: '#df2125A5',
  red_600_75: '#df2125BF',
  red_600_80: '#df2125CC',
  red_600_90: '#df2125E6',
  red_700: '#ba1f1d',
  red_700_5: '#ba1f1d0D',
  red_700_10: '#ba1f1d19',
  red_700_20: '#ba1f1d33',
  red_700_30: '#ba1f1d4D',
  red_700_40: '#ba1f1d66',
  red_700_50: '#ba1f1d80',
  red_700_65: '#ba1f1dA5',
  red_700_75: '#ba1f1dBF',
  red_700_80: '#ba1f1dCC',
  red_700_90: '#ba1f1dE6',
  red_800: '#971b1b',
  red_800_5: '#971b1b0D',
  red_800_10: '#971b1b19',
  red_800_20: '#971b1b33',
  red_800_30: '#971b1b4D',
  red_800_40: '#971b1b66',
  red_800_50: '#971b1b80',
  red_800_65: '#971b1bA5',
  red_800_75: '#971b1bBF',
  red_800_80: '#971b1bCC',
  red_800_90: '#971b1bE6',
  red_900: '#7f201e',
  red_900_5: '#7f201e0D',
  red_900_10: '#7f201e19',
  red_900_20: '#7f201e33',
  red_900_30: '#7f201e4D',
  red_900_40: '#7f201e66',
  red_900_50: '#7f201e80',
  red_900_65: '#7f201eA5',
  red_900_75: '#7f201eBF',
  red_900_80: '#7f201eCC',
  red_900_90: '#7f201eE6',
  red_950: '#46090a',
  red_950_5: '#46090a0D',
  red_950_10: '#46090a19',
  red_950_20: '#46090a33',
  red_950_30: '#46090a4D',
  red_950_40: '#46090a66',
  red_950_50: '#46090a80',
  red_950_65: '#46090aA5',
  red_950_75: '#46090aBF',
  red_950_80: '#46090aCC',
  red_950_90: '#46090aE6',

  orange_50: '#fff7eb',
  orange_50_5: '#fff7eb0D',
  orange_50_10: '#fff7eb19',
  orange_50_20: '#fff7eb33',
  orange_50_30: '#fff7eb4D',
  orange_50_40: '#fff7eb66',
  orange_50_50: '#fff7eb80',
  orange_50_65: '#fff7ebA5',
  orange_50_75: '#fff7ebBF',
  orange_50_80: '#fff7ebCC',
  orange_50_90: '#fff7ebE6',
  orange_100: '#ffebd2',
  orange_100_5: '#ffebd20D',
  orange_100_10: '#ffebd219',
  orange_100_20: '#ffebd233',
  orange_100_30: '#ffebd24D',
  orange_100_40: '#ffebd266',
  orange_100_50: '#ffebd280',
  orange_100_65: '#ffebd2A5',
  orange_100_75: '#ffebd2BF',
  orange_100_80: '#ffebd2CC',
  orange_100_90: '#ffebd2E6',
  orange_200: '#fcd8ac',
  orange_200_5: '#fcd8ac0D',
  orange_200_10: '#fcd8ac19',
  orange_200_20: '#fcd8ac33',
  orange_200_30: '#fcd8ac4D',
  orange_200_40: '#fcd8ac66',
  orange_200_50: '#fcd8ac80',
  orange_200_65: '#fcd8acA5',
  orange_200_75: '#fcd8acBF',
  orange_200_80: '#fcd8acCC',
  orange_200_90: '#fcd8acE6',
  orange_300: '#ffba73',
  orange_300_5: '#ffba730D',
  orange_300_10: '#ffba7319',
  orange_300_20: '#ffba7333',
  orange_300_30: '#ffba734D',
  orange_300_40: '#ffba7366',
  orange_300_50: '#ffba7380',
  orange_300_65: '#ffba73A5',
  orange_300_75: '#ffba73BF',
  orange_300_80: '#ffba73CC',
  orange_300_90: '#ffba73E6',
  orange_400: '#fc933b',
  orange_400_5: '#fc933b0D',
  orange_400_10: '#fc933b19',
  orange_400_20: '#fc933b33',
  orange_400_30: '#fc933b4D',
  orange_400_40: '#fc933b66',
  orange_400_50: '#fc933b80',
  orange_400_65: '#fc933bA5',
  orange_400_75: '#fc933bBF',
  orange_400_80: '#fc933bCC',
  orange_400_90: '#fc933bE6',
  orange_500: '#f97101',
  orange_500_5: '#f971010D',
  orange_500_10: '#f9710119',
  orange_500_20: '#f9710133',
  orange_500_30: '#f971014D',
  orange_500_40: '#f9710166',
  orange_500_50: '#f9710180',
  orange_500_65: '#f97101A5',
  orange_500_75: '#f97101BF',
  orange_500_80: '#f97101CC',
  orange_500_90: '#f97101E6',
  orange_600: '#ea5c19',
  orange_600_5: '#ea5c190D',
  orange_600_10: '#ea5c1919',
  orange_600_20: '#ea5c1933',
  orange_600_30: '#ea5c194D',
  orange_600_40: '#ea5c1966',
  orange_600_50: '#ea5c1980',
  orange_600_65: '#ea5c19A5',
  orange_600_75: '#ea5c19BF',
  orange_600_80: '#ea5c19CC',
  orange_600_90: '#ea5c19E6',
  orange_700: '#bf4212',
  orange_700_5: '#bf42120D',
  orange_700_10: '#bf421219',
  orange_700_20: '#bf421233',
  orange_700_30: '#bf42124D',
  orange_700_40: '#bf421266',
  orange_700_50: '#bf421280',
  orange_700_65: '#bf4212A5',
  orange_700_75: '#bf4212BF',
  orange_700_80: '#bf4212CC',
  orange_700_90: '#bf4212E6',
  orange_800: '#9a3516',
  orange_800_5: '#9a35160D',
  orange_800_10: '#9a351619',
  orange_800_20: '#9a351633',
  orange_800_30: '#9a35164D',
  orange_800_40: '#9a351666',
  orange_800_50: '#9a351680',
  orange_800_65: '#9a3516A5',
  orange_800_75: '#9a3516BF',
  orange_800_80: '#9a3516CC',
  orange_800_90: '#9a3516E6',
  orange_900: '#7f2d0f',
  orange_900_5: '#7f2d0f0D',
  orange_900_10: '#7f2d0f19',
  orange_900_20: '#7f2d0f33',
  orange_900_30: '#7f2d0f4D',
  orange_900_40: '#7f2d0f66',
  orange_900_50: '#7f2d0f80',
  orange_900_65: '#7f2d0fA5',
  orange_900_75: '#7f2d0fBF',
  orange_900_80: '#7f2d0fCC',
  orange_900_90: '#7f2d0fE6',
  orange_950: '#461407',
  orange_950_5: '#4614070D',
  orange_950_10: '#46140719',
  orange_950_20: '#46140733',
  orange_950_30: '#4614074D',
  orange_950_40: '#46140766',
  orange_950_50: '#46140780',
  orange_950_65: '#461407A5',
  orange_950_75: '#461407BF',
  orange_950_80: '#461407CC',
  orange_950_90: '#461407E6',

  amber_50: '#fffcee',
  amber_50_5: '#fffcee0D',
  amber_50_10: '#fffcee19',
  amber_50_20: '#fffcee33',
  amber_50_30: '#fffcee4D',
  amber_50_40: '#fffcee66',
  amber_50_50: '#fffcee80',
  amber_50_65: '#fffceeA5',
  amber_50_75: '#fffceeBF',
  amber_50_80: '#fffceeCC',
  amber_50_90: '#fffceeE6',
  amber_100: '#fef3c5',
  amber_100_5: '#fef3c50D',
  amber_100_10: '#fef3c519',
  amber_100_20: '#fef3c533',
  amber_100_30: '#fef3c54D',
  amber_100_40: '#fef3c566',
  amber_100_50: '#fef3c580',
  amber_100_65: '#fef3c5A5',
  amber_100_75: '#fef3c5BF',
  amber_100_80: '#fef3c5CC',
  amber_100_90: '#fef3c5E6',
  amber_200: '#fce584',
  amber_200_5: '#fce5840D',
  amber_200_10: '#fce58419',
  amber_200_20: '#fce58433',
  amber_200_30: '#fce5844D',
  amber_200_40: '#fce58466',
  amber_200_50: '#fce58480',
  amber_200_65: '#fce584A5',
  amber_200_75: '#fce584BF',
  amber_200_80: '#fce584CC',
  amber_200_90: '#fce584E6',
  amber_300: '#fbd452',
  amber_300_5: '#fbd4520D',
  amber_300_10: '#fbd45219',
  amber_300_20: '#fbd45233',
  amber_300_30: '#fbd4524D',
  amber_300_40: '#fbd45266',
  amber_300_50: '#fbd45280',
  amber_300_65: '#fbd452A5',
  amber_300_75: '#fbd452BF',
  amber_300_80: '#fbd452CC',
  amber_300_90: '#fbd452E6',
  amber_400: '#fbc130',
  amber_400_5: '#fbc1300D',
  amber_400_10: '#fbc13019',
  amber_400_20: '#fbc13033',
  amber_400_30: '#fbc1304D',
  amber_400_40: '#fbc13066',
  amber_400_50: '#fbc13080',
  amber_400_65: '#fbc130A5',
  amber_400_75: '#fbc130BF',
  amber_400_80: '#fbc130CC',
  amber_400_90: '#fbc130E6',
  amber_500: '#f49f1f',
  amber_500_5: '#f49f1f0D',
  amber_500_10: '#f49f1f19',
  amber_500_20: '#f49f1f33',
  amber_500_30: '#f49f1f4D',
  amber_500_40: '#f49f1f66',
  amber_500_50: '#f49f1f80',
  amber_500_65: '#f49f1fA5',
  amber_500_75: '#f49f1fBF',
  amber_500_80: '#f49f1fCC',
  amber_500_90: '#f49f1fE6',
  amber_600: '#dc7801',
  amber_600_5: '#dc78010D',
  amber_600_10: '#dc780119',
  amber_600_20: '#dc780133',
  amber_600_30: '#dc78014D',
  amber_600_40: '#dc780166',
  amber_600_50: '#dc780180',
  amber_600_65: '#dc7801A5',
  amber_600_75: '#dc7801BF',
  amber_600_80: '#dc7801CC',
  amber_600_90: '#dc7801E6',
  amber_700: '#b75300',
  amber_700_5: '#b753000D',
  amber_700_10: '#b7530019',
  amber_700_20: '#b7530033',
  amber_700_30: '#b753004D',
  amber_700_40: '#b7530066',
  amber_700_50: '#b7530080',
  amber_700_65: '#b75300A5',
  amber_700_75: '#b75300BF',
  amber_700_80: '#b75300CC',
  amber_700_90: '#b75300E6',
  amber_800: '#904013',
  amber_800_5: '#9040130D',
  amber_800_10: '#90401319',
  amber_800_20: '#90401333',
  amber_800_30: '#9040134D',
  amber_800_40: '#90401366',
  amber_800_50: '#90401380',
  amber_800_65: '#904013A5',
  amber_800_75: '#904013BF',
  amber_800_80: '#904013CC',
  amber_800_90: '#904013E6',
  amber_900: '#793307',
  amber_900_5: '#7933070D',
  amber_900_10: '#79330719',
  amber_900_20: '#79330733',
  amber_900_30: '#7933074D',
  amber_900_40: '#79330766',
  amber_900_50: '#79330780',
  amber_900_65: '#793307A5',
  amber_900_75: '#793307BF',
  amber_900_80: '#793307CC',
  amber_900_90: '#793307E6',
  amber_950: '#441c06',
  amber_950_5: '#441c060D',
  amber_950_10: '#441c0619',
  amber_950_20: '#441c0633',
  amber_950_30: '#441c064D',
  amber_950_40: '#441c0666',
  amber_950_50: '#441c0680',
  amber_950_65: '#441c06A5',
  amber_950_75: '#441c06BF',
  amber_950_80: '#441c06CC',
  amber_950_90: '#441c06E6',

  yellow_50: '#fffde7',
  yellow_50_5: '#fffde70D',
  yellow_50_10: '#fffde719',
  yellow_50_20: '#fffde733',
  yellow_50_30: '#fffde74D',
  yellow_50_40: '#fffde766',
  yellow_50_50: '#fffde780',
  yellow_50_65: '#fffde7A5',
  yellow_50_75: '#fffde7BF',
  yellow_50_80: '#fffde7CC',
  yellow_50_90: '#fffde7E6',
  yellow_100: '#fef8c2',
  yellow_100_5: '#fef8c20D',
  yellow_100_10: '#fef8c219',
  yellow_100_20: '#fef8c233',
  yellow_100_30: '#fef8c24D',
  yellow_100_40: '#fef8c266',
  yellow_100_50: '#fef8c280',
  yellow_100_65: '#fef8c2A5',
  yellow_100_75: '#fef8c2BF',
  yellow_100_80: '#fef8c2CC',
  yellow_100_90: '#fef8c2E6',
  yellow_200: '#fef390',
  yellow_200_5: '#fef3900D',
  yellow_200_10: '#fef39019',
  yellow_200_20: '#fef39033',
  yellow_200_30: '#fef3904D',
  yellow_200_40: '#fef39066',
  yellow_200_50: '#fef39080',
  yellow_200_65: '#fef390A5',
  yellow_200_75: '#fef390BF',
  yellow_200_80: '#fef390CC',
  yellow_200_90: '#fef390E6',
  yellow_300: '#ffe242',
  yellow_300_5: '#ffe2420D',
  yellow_300_10: '#ffe24219',
  yellow_300_20: '#ffe24233',
  yellow_300_30: '#ffe2424D',
  yellow_300_40: '#ffe24266',
  yellow_300_50: '#ffe24280',
  yellow_300_65: '#ffe242A5',
  yellow_300_75: '#ffe242BF',
  yellow_300_80: '#ffe242CC',
  yellow_300_90: '#ffe242E6',
  yellow_400: '#f9cc21',
  yellow_400_5: '#f9cc210D',
  yellow_400_10: '#f9cc2119',
  yellow_400_20: '#f9cc2133',
  yellow_400_30: '#f9cc214D',
  yellow_400_40: '#f9cc2166',
  yellow_400_50: '#f9cc2180',
  yellow_400_65: '#f9cc21A5',
  yellow_400_75: '#f9cc21BF',
  yellow_400_80: '#f9cc21CC',
  yellow_400_90: '#f9cc21E6',
  yellow_500: '#ebb518',
  yellow_500_5: '#ebb5180D',
  yellow_500_10: '#ebb51819',
  yellow_500_20: '#ebb51833',
  yellow_500_30: '#ebb5184D',
  yellow_500_40: '#ebb51866',
  yellow_500_50: '#ebb51880',
  yellow_500_65: '#ebb518A5',
  yellow_500_75: '#ebb518BF',
  yellow_500_80: '#ebb518CC',
  yellow_500_90: '#ebb518E6',
  yellow_600: '#c98a10',
  yellow_600_5: '#c98a100D',
  yellow_600_10: '#c98a1019',
  yellow_600_20: '#c98a1033',
  yellow_600_30: '#c98a104D',
  yellow_600_40: '#c98a1066',
  yellow_600_50: '#c98a1080',
  yellow_600_65: '#c98a10A5',
  yellow_600_75: '#c98a10BF',
  yellow_600_80: '#c98a10CC',
  yellow_600_90: '#c98a10E6',
  yellow_700: '#a06108',
  yellow_700_5: '#a061080D',
  yellow_700_10: '#a0610819',
  yellow_700_20: '#a0610833',
  yellow_700_30: '#a061084D',
  yellow_700_40: '#a0610866',
  yellow_700_50: '#a0610880',
  yellow_700_65: '#a06108A5',
  yellow_700_75: '#a06108BF',
  yellow_700_80: '#a06108CC',
  yellow_700_90: '#a06108E6',
  yellow_800: '#864f15',
  yellow_800_5: '#864f150D',
  yellow_800_10: '#864f1519',
  yellow_800_20: '#864f1533',
  yellow_800_30: '#864f154D',
  yellow_800_40: '#864f1566',
  yellow_800_50: '#864f1580',
  yellow_800_65: '#864f15A5',
  yellow_800_75: '#864f15BF',
  yellow_800_80: '#864f15CC',
  yellow_800_90: '#864f15E6',
  yellow_900: '#713f11',
  yellow_900_5: '#713f110D',
  yellow_900_10: '#713f1119',
  yellow_900_20: '#713f1133',
  yellow_900_30: '#713f114D',
  yellow_900_40: '#713f1166',
  yellow_900_50: '#713f1180',
  yellow_900_65: '#713f11A5',
  yellow_900_75: '#713f11BF',
  yellow_900_80: '#713f11CC',
  yellow_900_90: '#713f11E6',
  yellow_950: '#42220a',
  yellow_950_5: '#42220a0D',
  yellow_950_10: '#42220a19',
  yellow_950_20: '#42220a33',
  yellow_950_30: '#42220a4D',
  yellow_950_40: '#42220a66',
  yellow_950_50: '#42220a80',
  yellow_950_65: '#42220aA5',
  yellow_950_75: '#42220aBF',
  yellow_950_80: '#42220aCC',
  yellow_950_90: '#42220aE6',

  lime_50: '#f9ffe9',
  lime_50_5: '#f9ffe90D',
  lime_50_10: '#f9ffe919',
  lime_50_20: '#f9ffe933',
  lime_50_30: '#f9ffe94D',
  lime_50_40: '#f9ffe966',
  lime_50_50: '#f9ffe980',
  lime_50_65: '#f9ffe9A5',
  lime_50_75: '#f9ffe9BF',
  lime_50_80: '#f9ffe9CC',
  lime_50_90: '#f9ffe9E6',
  lime_100: '#edfec9',
  lime_100_5: '#edfec90D',
  lime_100_10: '#edfec919',
  lime_100_20: '#edfec933',
  lime_100_30: '#edfec94D',
  lime_100_40: '#edfec966',
  lime_100_50: '#edfec980',
  lime_100_65: '#edfec9A5',
  lime_100_75: '#edfec9BF',
  lime_100_80: '#edfec9CC',
  lime_100_90: '#edfec9E6',
  lime_200: '#dafa9f',
  lime_200_5: '#dafa9f0D',
  lime_200_10: '#dafa9f19',
  lime_200_20: '#dafa9f33',
  lime_200_30: '#dafa9f4D',
  lime_200_40: '#dafa9f66',
  lime_200_50: '#dafa9f80',
  lime_200_65: '#dafa9fA5',
  lime_200_75: '#dafa9fBF',
  lime_200_80: '#dafa9fCC',
  lime_200_90: '#dafa9fE6',
  lime_300: '#bef464',
  lime_300_5: '#bef4640D',
  lime_300_10: '#bef46419',
  lime_300_20: '#bef46433',
  lime_300_30: '#bef4644D',
  lime_300_40: '#bef46466',
  lime_300_50: '#bef46480',
  lime_300_65: '#bef464A5',
  lime_300_75: '#bef464BF',
  lime_300_80: '#bef464CC',
  lime_300_90: '#bef464E6',
  lime_400: '#a2e732',
  lime_400_5: '#a2e7320D',
  lime_400_10: '#a2e73219',
  lime_400_20: '#a2e73233',
  lime_400_30: '#a2e7324D',
  lime_400_40: '#a2e73266',
  lime_400_50: '#a2e73280',
  lime_400_65: '#a2e732A5',
  lime_400_75: '#a2e732BF',
  lime_400_80: '#a2e732CC',
  lime_400_90: '#a2e732E6',
  lime_500: '#85cd22',
  lime_500_5: '#85cd220D',
  lime_500_10: '#85cd2219',
  lime_500_20: '#85cd2233',
  lime_500_30: '#85cd224D',
  lime_500_40: '#85cd2266',
  lime_500_50: '#85cd2280',
  lime_500_65: '#85cd22A5',
  lime_500_75: '#85cd22BF',
  lime_500_80: '#85cd22CC',
  lime_500_90: '#85cd22E6',
  lime_600: '#64a501',
  lime_600_5: '#64a5010D',
  lime_600_10: '#64a50119',
  lime_600_20: '#64a50133',
  lime_600_30: '#64a5014D',
  lime_600_40: '#64a50166',
  lime_600_50: '#64a50180',
  lime_600_65: '#64a501A5',
  lime_600_75: '#64a501BF',
  lime_600_80: '#64a501CC',
  lime_600_90: '#64a501E6',
  lime_700: '#4c7b10',
  lime_700_5: '#4c7b100D',
  lime_700_10: '#4c7b1019',
  lime_700_20: '#4c7b1033',
  lime_700_30: '#4c7b104D',
  lime_700_40: '#4c7b1066',
  lime_700_50: '#4c7b1080',
  lime_700_65: '#4c7b10A5',
  lime_700_75: '#4c7b10BF',
  lime_700_80: '#4c7b10CC',
  lime_700_90: '#4c7b10E6',
  lime_800: '#406114',
  lime_800_5: '#4061140D',
  lime_800_10: '#40611419',
  lime_800_20: '#40611433',
  lime_800_30: '#4061144D',
  lime_800_40: '#40611466',
  lime_800_50: '#40611480',
  lime_800_65: '#406114A5',
  lime_800_75: '#406114BF',
  lime_800_80: '#406114CC',
  lime_800_90: '#406114E6',
  lime_900: '#365511',
  lime_900_5: '#3655110D',
  lime_900_10: '#36551119',
  lime_900_20: '#36551133',
  lime_900_30: '#3655114D',
  lime_900_40: '#36551166',
  lime_900_50: '#36551180',
  lime_900_65: '#365511A5',
  lime_900_75: '#365511BF',
  lime_900_80: '#365511CC',
  lime_900_90: '#365511E6',
  lime_950: '#182e03',
  lime_950_5: '#182e030D',
  lime_950_10: '#182e0319',
  lime_950_20: '#182e0333',
  lime_950_30: '#182e034D',
  lime_950_40: '#182e0366',
  lime_950_50: '#182e0380',
  lime_950_65: '#182e03A5',
  lime_950_75: '#182e03BF',
  lime_950_80: '#182e03CC',
  lime_950_90: '#182e03E6',

  green_50: '#eefdf3',
  green_50_5: '#eefdf30D',
  green_50_10: '#eefdf319',
  green_50_20: '#eefdf333',
  green_50_30: '#eefdf34D',
  green_50_40: '#eefdf366',
  green_50_50: '#eefdf380',
  green_50_65: '#eefdf3A5',
  green_50_75: '#eefdf3BF',
  green_50_80: '#eefdf3CC',
  green_50_90: '#eefdf3E6',
  green_100: '#ddfbe8',
  green_100_5: '#ddfbe80D',
  green_100_10: '#ddfbe819',
  green_100_20: '#ddfbe833',
  green_100_30: '#ddfbe84D',
  green_100_40: '#ddfbe866',
  green_100_50: '#ddfbe880',
  green_100_65: '#ddfbe8A5',
  green_100_75: '#ddfbe8BF',
  green_100_80: '#ddfbe8CC',
  green_100_90: '#ddfbe8E6',
  green_200: '#bdf9d2',
  green_200_5: '#bdf9d20D',
  green_200_10: '#bdf9d219',
  green_200_20: '#bdf9d233',
  green_200_30: '#bdf9d24D',
  green_200_40: '#bdf9d266',
  green_200_50: '#bdf9d280',
  green_200_65: '#bdf9d2A5',
  green_200_75: '#bdf9d2BF',
  green_200_80: '#bdf9d2CC',
  green_200_90: '#bdf9d2E6',
  green_300: '#83f0aa',
  green_300_5: '#83f0aa0D',
  green_300_10: '#83f0aa19',
  green_300_20: '#83f0aa33',
  green_300_30: '#83f0aa4D',
  green_300_40: '#83f0aa66',
  green_300_50: '#83f0aa80',
  green_300_65: '#83f0aaA5',
  green_300_75: '#83f0aaBF',
  green_300_80: '#83f0aaCC',
  green_300_90: '#83f0aaE6',
  green_400: '#4bde81',
  green_400_5: '#4bde810D',
  green_400_10: '#4bde8119',
  green_400_20: '#4bde8133',
  green_400_30: '#4bde814D',
  green_400_40: '#4bde8166',
  green_400_50: '#4bde8180',
  green_400_65: '#4bde81A5',
  green_400_75: '#4bde81BF',
  green_400_80: '#4bde81CC',
  green_400_90: '#4bde81E6',
  green_500: '#20c460',
  green_500_5: '#20c4600D',
  green_500_10: '#20c46019',
  green_500_20: '#20c46033',
  green_500_30: '#20c4604D',
  green_500_40: '#20c46066',
  green_500_50: '#20c46080',
  green_500_65: '#20c460A5',
  green_500_75: '#20c460BF',
  green_500_80: '#20c460CC',
  green_500_90: '#20c460E6',
  green_600: '#19a44b',
  green_600_5: '#19a44b0D',
  green_600_10: '#19a44b19',
  green_600_20: '#19a44b33',
  green_600_30: '#19a44b4D',
  green_600_40: '#19a44b66',
  green_600_50: '#19a44b80',
  green_600_65: '#19a44bA5',
  green_600_75: '#19a44bBF',
  green_600_80: '#19a44bCC',
  green_600_90: '#19a44bE6',
  green_700: '#12813d',
  green_700_5: '#12813d0D',
  green_700_10: '#12813d19',
  green_700_20: '#12813d33',
  green_700_30: '#12813d4D',
  green_700_40: '#12813d66',
  green_700_50: '#12813d80',
  green_700_65: '#12813dA5',
  green_700_75: '#12813dBF',
  green_700_80: '#12813dCC',
  green_700_90: '#12813dE6',
  green_800: '#186634',
  green_800_5: '#1866340D',
  green_800_10: '#18663419',
  green_800_20: '#18663433',
  green_800_30: '#1866344D',
  green_800_40: '#18663466',
  green_800_50: '#18663480',
  green_800_65: '#186634A5',
  green_800_75: '#186634BF',
  green_800_80: '#186634CC',
  green_800_90: '#186634E6',
  green_900: '#13522c',
  green_900_5: '#13522c0D',
  green_900_10: '#13522c19',
  green_900_20: '#13522c33',
  green_900_30: '#13522c4D',
  green_900_40: '#13522c66',
  green_900_50: '#13522c80',
  green_900_65: '#13522cA5',
  green_900_75: '#13522cBF',
  green_900_80: '#13522cCC',
  green_900_90: '#13522cE6',
  green_950: '#082f18',
  green_950_5: '#082f180D',
  green_950_10: '#082f1819',
  green_950_20: '#082f1833',
  green_950_30: '#082f184D',
  green_950_40: '#082f1866',
  green_950_50: '#082f1880',
  green_950_65: '#082f18A5',
  green_950_75: '#082f18BF',
  green_950_80: '#082f18CC',
  green_950_90: '#082f18E6',

  emerald_50: '#edfef6',
  emerald_50_5: '#edfef60D',
  emerald_50_10: '#edfef619',
  emerald_50_20: '#edfef633',
  emerald_50_30: '#edfef64D',
  emerald_50_40: '#edfef666',
  emerald_50_50: '#edfef680',
  emerald_50_65: '#edfef6A5',
  emerald_50_75: '#edfef6BF',
  emerald_50_80: '#edfef6CC',
  emerald_50_90: '#edfef6E6',
  emerald_100: '#d1fae5',
  emerald_100_5: '#d1fae50D',
  emerald_100_10: '#d1fae519',
  emerald_100_20: '#d1fae533',
  emerald_100_30: '#d1fae54D',
  emerald_100_40: '#d1fae566',
  emerald_100_50: '#d1fae580',
  emerald_100_65: '#d1fae5A5',
  emerald_100_75: '#d1fae5BF',
  emerald_100_80: '#d1fae5CC',
  emerald_100_90: '#d1fae5E6',
  emerald_200: '#a5f2cf',
  emerald_200_5: '#a5f2cf0D',
  emerald_200_10: '#a5f2cf19',
  emerald_200_20: '#a5f2cf33',
  emerald_200_30: '#a5f2cf4D',
  emerald_200_40: '#a5f2cf66',
  emerald_200_50: '#a5f2cf80',
  emerald_200_65: '#a5f2cfA5',
  emerald_200_75: '#a5f2cfBF',
  emerald_200_80: '#a5f2cfCC',
  emerald_200_90: '#a5f2cfE6',
  emerald_300: '#71e9b9',
  emerald_300_5: '#71e9b90D',
  emerald_300_10: '#71e9b919',
  emerald_300_20: '#71e9b933',
  emerald_300_30: '#71e9b94D',
  emerald_300_40: '#71e9b966',
  emerald_300_50: '#71e9b980',
  emerald_300_65: '#71e9b9A5',
  emerald_300_75: '#71e9b9BF',
  emerald_300_80: '#71e9b9CC',
  emerald_300_90: '#71e9b9E6',
  emerald_400: '#3bd299',
  emerald_400_5: '#3bd2990D',
  emerald_400_10: '#3bd29919',
  emerald_400_20: '#3bd29933',
  emerald_400_30: '#3bd2994D',
  emerald_400_40: '#3bd29966',
  emerald_400_50: '#3bd29980',
  emerald_400_65: '#3bd299A5',
  emerald_400_75: '#3bd299BF',
  emerald_400_80: '#3bd299CC',
  emerald_400_90: '#3bd299E6',
  emerald_500: '#18bb82',
  emerald_500_5: '#18bb820D',
  emerald_500_10: '#18bb8219',
  emerald_500_20: '#18bb8233',
  emerald_500_30: '#18bb824D',
  emerald_500_40: '#18bb8266',
  emerald_500_50: '#18bb8280',
  emerald_500_65: '#18bb82A5',
  emerald_500_75: '#18bb82BF',
  emerald_500_80: '#18bb82CC',
  emerald_500_90: '#18bb82E6',
  emerald_600: '#00986a',
  emerald_600_5: '#00986a0D',
  emerald_600_10: '#00986a19',
  emerald_600_20: '#00986a33',
  emerald_600_30: '#00986a4D',
  emerald_600_40: '#00986a66',
  emerald_600_50: '#00986a80',
  emerald_600_65: '#00986aA5',
  emerald_600_75: '#00986aBF',
  emerald_600_80: '#00986aCC',
  emerald_600_90: '#00986aE6',
  emerald_700: '#157859',
  emerald_700_5: '#1578590D',
  emerald_700_10: '#15785919',
  emerald_700_20: '#15785933',
  emerald_700_30: '#1578594D',
  emerald_700_40: '#15785966',
  emerald_700_50: '#15785980',
  emerald_700_65: '#157859A5',
  emerald_700_75: '#157859BF',
  emerald_700_80: '#157859CC',
  emerald_700_90: '#157859E6',
  emerald_800: '#006045',
  emerald_800_5: '#0060450D',
  emerald_800_10: '#00604519',
  emerald_800_20: '#00604533',
  emerald_800_30: '#0060454D',
  emerald_800_40: '#00604566',
  emerald_800_50: '#00604580',
  emerald_800_65: '#006045A5',
  emerald_800_75: '#006045BF',
  emerald_800_80: '#006045CC',
  emerald_800_90: '#006045E6',
  emerald_900: '#0d4e3c',
  emerald_900_5: '#0d4e3c0D',
  emerald_900_10: '#0d4e3c19',
  emerald_900_20: '#0d4e3c33',
  emerald_900_30: '#0d4e3c4D',
  emerald_900_40: '#0d4e3c66',
  emerald_900_50: '#0d4e3c80',
  emerald_900_65: '#0d4e3cA5',
  emerald_900_75: '#0d4e3cBF',
  emerald_900_80: '#0d4e3cCC',
  emerald_900_90: '#0d4e3cE6',
  emerald_950: '#002c21',
  emerald_950_5: '#002c210D',
  emerald_950_10: '#002c2119',
  emerald_950_20: '#002c2133',
  emerald_950_30: '#002c214D',
  emerald_950_40: '#002c2166',
  emerald_950_50: '#002c2180',
  emerald_950_65: '#002c21A5',
  emerald_950_75: '#002c21BF',
  emerald_950_80: '#002c21CC',
  emerald_950_90: '#002c21E6',

  teal_50: '#f2fbf9',
  teal_50_5: '#f2fbf90D',
  teal_50_10: '#f2fbf919',
  teal_50_20: '#f2fbf933',
  teal_50_30: '#f2fbf94D',
  teal_50_40: '#f2fbf966',
  teal_50_50: '#f2fbf980',
  teal_50_65: '#f2fbf9A5',
  teal_50_75: '#f2fbf9BF',
  teal_50_80: '#f2fbf9CC',
  teal_50_90: '#f2fbf9E6',
  teal_100: '#ccfaf1',
  teal_100_5: '#ccfaf10D',
  teal_100_10: '#ccfaf119',
  teal_100_20: '#ccfaf133',
  teal_100_30: '#ccfaf14D',
  teal_100_40: '#ccfaf166',
  teal_100_50: '#ccfaf180',
  teal_100_65: '#ccfaf1A5',
  teal_100_75: '#ccfaf1BF',
  teal_100_80: '#ccfaf1CC',
  teal_100_90: '#ccfaf1E6',
  teal_200: '#9df5e4',
  teal_200_5: '#9df5e40D',
  teal_200_10: '#9df5e419',
  teal_200_20: '#9df5e433',
  teal_200_30: '#9df5e44D',
  teal_200_40: '#9df5e466',
  teal_200_50: '#9df5e480',
  teal_200_65: '#9df5e4A5',
  teal_200_75: '#9df5e4BF',
  teal_200_80: '#9df5e4CC',
  teal_200_90: '#9df5e4E6',
  teal_300: '#55e9d3',
  teal_300_5: '#55e9d30D',
  teal_300_10: '#55e9d319',
  teal_300_20: '#55e9d333',
  teal_300_30: '#55e9d34D',
  teal_300_40: '#55e9d366',
  teal_300_50: '#55e9d380',
  teal_300_65: '#55e9d3A5',
  teal_300_75: '#55e9d3BF',
  teal_300_80: '#55e9d3CC',
  teal_300_90: '#55e9d3E6',
  teal_400: '#33d2be',
  teal_400_5: '#33d2be0D',
  teal_400_10: '#33d2be19',
  teal_400_20: '#33d2be33',
  teal_400_30: '#33d2be4D',
  teal_400_40: '#33d2be66',
  teal_400_50: '#33d2be80',
  teal_400_65: '#33d2beA5',
  teal_400_75: '#33d2beBF',
  teal_400_80: '#33d2beCC',
  teal_400_90: '#33d2beE6',
  teal_500: '#1cb7a6',
  teal_500_5: '#1cb7a60D',
  teal_500_10: '#1cb7a619',
  teal_500_20: '#1cb7a633',
  teal_500_30: '#1cb7a64D',
  teal_500_40: '#1cb7a666',
  teal_500_50: '#1cb7a680',
  teal_500_65: '#1cb7a6A5',
  teal_500_75: '#1cb7a6BF',
  teal_500_80: '#1cb7a6CC',
  teal_500_90: '#1cb7a6E6',
  teal_600: '#1c9388',
  teal_600_5: '#1c93880D',
  teal_600_10: '#1c938819',
  teal_600_20: '#1c938833',
  teal_600_30: '#1c93884D',
  teal_600_40: '#1c938866',
  teal_600_50: '#1c938880',
  teal_600_65: '#1c9388A5',
  teal_600_75: '#1c9388BF',
  teal_600_80: '#1c9388CC',
  teal_600_90: '#1c9388E6',
  teal_700: '#00776e',
  teal_700_5: '#00776e0D',
  teal_700_10: '#00776e19',
  teal_700_20: '#00776e33',
  teal_700_30: '#00776e4D',
  teal_700_40: '#00776e66',
  teal_700_50: '#00776e80',
  teal_700_65: '#00776eA5',
  teal_700_75: '#00776eBF',
  teal_700_80: '#00776eCC',
  teal_700_90: '#00776eE6',
  teal_800: '#145f5a',
  teal_800_5: '#145f5a0D',
  teal_800_10: '#145f5a19',
  teal_800_20: '#145f5a33',
  teal_800_30: '#145f5a4D',
  teal_800_40: '#145f5a66',
  teal_800_50: '#145f5a80',
  teal_800_65: '#145f5aA5',
  teal_800_75: '#145f5aBF',
  teal_800_80: '#145f5aCC',
  teal_800_90: '#145f5aE6',
  teal_900: '#134f4b',
  teal_900_5: '#134f4b0D',
  teal_900_10: '#134f4b19',
  teal_900_20: '#134f4b33',
  teal_900_30: '#134f4b4D',
  teal_900_40: '#134f4b66',
  teal_900_50: '#134f4b80',
  teal_900_65: '#134f4bA5',
  teal_900_75: '#134f4bBF',
  teal_900_80: '#134f4bCC',
  teal_900_90: '#134f4bE6',
  teal_950: '#0c2f2e',
  teal_950_5: '#0c2f2e0D',
  teal_950_10: '#0c2f2e19',
  teal_950_20: '#0c2f2e33',
  teal_950_30: '#0c2f2e4D',
  teal_950_40: '#0c2f2e66',
  teal_950_50: '#0c2f2e80',
  teal_950_65: '#0c2f2eA5',
  teal_950_75: '#0c2f2eBF',
  teal_950_80: '#0c2f2eCC',
  teal_950_90: '#0c2f2eE6',

  cyan_50: '#ebfdfe',
  cyan_50_5: '#ebfdfe0D',
  cyan_50_10: '#ebfdfe19',
  cyan_50_20: '#ebfdfe33',
  cyan_50_30: '#ebfdfe4D',
  cyan_50_40: '#ebfdfe66',
  cyan_50_50: '#ebfdfe80',
  cyan_50_65: '#ebfdfeA5',
  cyan_50_75: '#ebfdfeBF',
  cyan_50_80: '#ebfdfeCC',
  cyan_50_90: '#ebfdfeE6',
  cyan_100: '#d3fafe',
  cyan_100_5: '#d3fafe0D',
  cyan_100_10: '#d3fafe19',
  cyan_100_20: '#d3fafe33',
  cyan_100_30: '#d3fafe4D',
  cyan_100_40: '#d3fafe66',
  cyan_100_50: '#d3fafe80',
  cyan_100_65: '#d3fafeA5',
  cyan_100_75: '#d3fafeBF',
  cyan_100_80: '#d3fafeCC',
  cyan_100_90: '#d3fafeE6',
  cyan_200: '#a4f5fe',
  cyan_200_5: '#a4f5fe0D',
  cyan_200_10: '#a4f5fe19',
  cyan_200_20: '#a4f5fe33',
  cyan_200_30: '#a4f5fe4D',
  cyan_200_40: '#a4f5fe66',
  cyan_200_50: '#a4f5fe80',
  cyan_200_65: '#a4f5feA5',
  cyan_200_75: '#a4f5feBF',
  cyan_200_80: '#a4f5feCC',
  cyan_200_90: '#a4f5feE6',
  cyan_300: '#61ebfc',
  cyan_300_5: '#61ebfc0D',
  cyan_300_10: '#61ebfc19',
  cyan_300_20: '#61ebfc33',
  cyan_300_30: '#61ebfc4D',
  cyan_300_40: '#61ebfc66',
  cyan_300_50: '#61ebfc80',
  cyan_300_65: '#61ebfcA5',
  cyan_300_75: '#61ebfcBF',
  cyan_300_80: '#61ebfcCC',
  cyan_300_90: '#61ebfcE6',
  cyan_400: '#00b5d4',
  cyan_400_5: '#00b5d40D',
  cyan_400_10: '#00b5d419',
  cyan_400_20: '#00b5d433',
  cyan_400_30: '#00b5d44D',
  cyan_400_40: '#00b5d466',
  cyan_400_50: '#00b5d480',
  cyan_400_65: '#00b5d4A5',
  cyan_400_75: '#00b5d4BF',
  cyan_400_80: '#00b5d4CC',
  cyan_400_90: '#00b5d4E6',
  cyan_500: '#00b5d4',
  cyan_500_5: '#00b5d40D',
  cyan_500_10: '#00b5d419',
  cyan_500_20: '#00b5d433',
  cyan_500_30: '#00b5d44D',
  cyan_500_40: '#00b5d466',
  cyan_500_50: '#00b5d480',
  cyan_500_65: '#00b5d4A5',
  cyan_500_75: '#00b5d4BF',
  cyan_500_80: '#00b5d4CC',
  cyan_500_90: '#00b5d4E6',
  cyan_600: '#0f91b3',
  cyan_600_5: '#0f91b30D',
  cyan_600_10: '#0f91b319',
  cyan_600_20: '#0f91b333',
  cyan_600_30: '#0f91b34D',
  cyan_600_40: '#0f91b366',
  cyan_600_50: '#0f91b380',
  cyan_600_65: '#0f91b3A5',
  cyan_600_75: '#0f91b3BF',
  cyan_600_80: '#0f91b3CC',
  cyan_600_90: '#0f91b3E6',
  cyan_700: '#18748f',
  cyan_700_5: '#18748f0D',
  cyan_700_10: '#18748f19',
  cyan_700_20: '#18748f33',
  cyan_700_30: '#18748f4D',
  cyan_700_40: '#18748f66',
  cyan_700_50: '#18748f80',
  cyan_700_65: '#18748fA5',
  cyan_700_75: '#18748fBF',
  cyan_700_80: '#18748fCC',
  cyan_700_90: '#18748fE6',
  cyan_800: '#0f5e76',
  cyan_800_5: '#0f5e760D',
  cyan_800_10: '#0f5e7619',
  cyan_800_20: '#0f5e7633',
  cyan_800_30: '#0f5e764D',
  cyan_800_40: '#0f5e7666',
  cyan_800_50: '#0f5e7680',
  cyan_800_65: '#0f5e76A5',
  cyan_800_75: '#0f5e76BF',
  cyan_800_80: '#0f5e76CC',
  cyan_800_90: '#0f5e76E6',
  cyan_900: '#114f65',
  cyan_900_5: '#114f650D',
  cyan_900_10: '#114f6519',
  cyan_900_20: '#114f6533',
  cyan_900_30: '#114f654D',
  cyan_900_40: '#114f6566',
  cyan_900_50: '#114f6580',
  cyan_900_65: '#114f65A5',
  cyan_900_75: '#114f65BF',
  cyan_900_80: '#114f65CC',
  cyan_900_90: '#114f65E6',
  cyan_950: '#0d3343',
  cyan_950_5: '#0d33430D',
  cyan_950_10: '#0d334319',
  cyan_950_20: '#0d334333',
  cyan_950_30: '#0d33434D',
  cyan_950_40: '#0d334366',
  cyan_950_50: '#0d334380',
  cyan_950_65: '#0d3343A5',
  cyan_950_75: '#0d3343BF',
  cyan_950_80: '#0d3343CC',
  cyan_950_90: '#0d3343E6',

  sky_50: '#f3faff',
  sky_50_5: '#f3faff0D',
  sky_50_10: '#f3faff19',
  sky_50_20: '#f3faff33',
  sky_50_30: '#f3faff4D',
  sky_50_40: '#f3faff66',
  sky_50_50: '#f3faff80',
  sky_50_65: '#f3faffA5',
  sky_50_75: '#f3faffBF',
  sky_50_80: '#f3faffCC',
  sky_50_90: '#f3faffE6',
  sky_100: '#ddf3ff',
  sky_100_5: '#ddf3ff0D',
  sky_100_10: '#ddf3ff19',
  sky_100_20: '#ddf3ff33',
  sky_100_30: '#ddf3ff4D',
  sky_100_40: '#ddf3ff66',
  sky_100_50: '#ddf3ff80',
  sky_100_65: '#ddf3ffA5',
  sky_100_75: '#ddf3ffBF',
  sky_100_80: '#ddf3ffCC',
  sky_100_90: '#ddf3ffE6',
  sky_200: '#b6e6ff',
  sky_200_5: '#b6e6ff0D',
  sky_200_10: '#b6e6ff19',
  sky_200_20: '#b6e6ff33',
  sky_200_30: '#b6e6ff4D',
  sky_200_40: '#b6e6ff66',
  sky_200_50: '#b6e6ff80',
  sky_200_65: '#b6e6ffA5',
  sky_200_75: '#b6e6ffBF',
  sky_200_80: '#b6e6ffCC',
  sky_200_90: '#b6e6ffE6',
  sky_300: '#7fd4fc',
  sky_300_5: '#7fd4fc0D',
  sky_300_10: '#7fd4fc19',
  sky_300_20: '#7fd4fc33',
  sky_300_30: '#7fd4fc4D',
  sky_300_40: '#7fd4fc66',
  sky_300_50: '#7fd4fc80',
  sky_300_65: '#7fd4fcA5',
  sky_300_75: '#7fd4fcBF',
  sky_300_80: '#7fd4fcCC',
  sky_300_90: '#7fd4fcE6',
  sky_400: '#36bcf8',
  sky_400_5: '#36bcf80D',
  sky_400_10: '#36bcf819',
  sky_400_20: '#36bcf833',
  sky_400_30: '#36bcf84D',
  sky_400_40: '#36bcf866',
  sky_400_50: '#36bcf880',
  sky_400_65: '#36bcf8A5',
  sky_400_75: '#36bcf8BF',
  sky_400_80: '#36bcf8CC',
  sky_400_90: '#36bcf8E6',
  sky_500: '#00a3e9',
  sky_500_5: '#00a3e90D',
  sky_500_10: '#00a3e919',
  sky_500_20: '#00a3e933',
  sky_500_30: '#00a3e94D',
  sky_500_40: '#00a3e966',
  sky_500_50: '#00a3e980',
  sky_500_65: '#00a3e9A5',
  sky_500_75: '#00a3e9BF',
  sky_500_80: '#00a3e9CC',
  sky_500_90: '#00a3e9E6',
  sky_600: '#0385c8',
  sky_600_5: '#0385c80D',
  sky_600_10: '#0385c819',
  sky_600_20: '#0385c833',
  sky_600_30: '#0385c84D',
  sky_600_40: '#0385c866',
  sky_600_50: '#0385c880',
  sky_600_65: '#0385c8A5',
  sky_600_75: '#0385c8BF',
  sky_600_80: '#0385c8CC',
  sky_600_90: '#0385c8E6',
  sky_700: '#0569a2',
  sky_700_5: '#0569a20D',
  sky_700_10: '#0569a219',
  sky_700_20: '#0569a233',
  sky_700_30: '#0569a24D',
  sky_700_40: '#0569a266',
  sky_700_50: '#0569a280',
  sky_700_65: '#0569a2A5',
  sky_700_75: '#0569a2BF',
  sky_700_80: '#0569a2CC',
  sky_700_90: '#0569a2E6',
  sky_800: '#045885',
  sky_800_5: '#0458850D',
  sky_800_10: '#04588519',
  sky_800_20: '#04588533',
  sky_800_30: '#0458854D',
  sky_800_40: '#04588566',
  sky_800_50: '#04588580',
  sky_800_65: '#045885A5',
  sky_800_75: '#045885BF',
  sky_800_80: '#045885CC',
  sky_800_90: '#045885E6',
  sky_900: '#114a6c',
  sky_900_5: '#114a6c0D',
  sky_900_10: '#114a6c19',
  sky_900_20: '#114a6c33',
  sky_900_30: '#114a6c4D',
  sky_900_40: '#114a6c66',
  sky_900_50: '#114a6c80',
  sky_900_65: '#114a6cA5',
  sky_900_75: '#114a6cBF',
  sky_900_80: '#114a6cCC',
  sky_900_90: '#114a6cE6',
  sky_950: '#0a2f47',
  sky_950_5: '#0a2f470D',
  sky_950_10: '#0a2f4719',
  sky_950_20: '#0a2f4733',
  sky_950_30: '#0a2f474D',
  sky_950_40: '#0a2f4766',
  sky_950_50: '#0a2f4780',
  sky_950_65: '#0a2f47A5',
  sky_950_75: '#0a2f47BF',
  sky_950_80: '#0a2f47CC',
  sky_950_90: '#0a2f47E6',

  blue_50: '#f1f6fd',
  blue_50_5: '#f1f6fd0D',
  blue_50_10: '#f1f6fd19',
  blue_50_20: '#f1f6fd33',
  blue_50_30: '#f1f6fd4D',
  blue_50_40: '#f1f6fd66',
  blue_50_50: '#f1f6fd80',
  blue_50_65: '#f1f6fdA5',
  blue_50_75: '#f1f6fdBF',
  blue_50_80: '#f1f6fdCC',
  blue_50_90: '#f1f6fdE6',
  blue_100: '#dbe9fd',
  blue_100_5: '#dbe9fd0D',
  blue_100_10: '#dbe9fd19',
  blue_100_20: '#dbe9fd33',
  blue_100_30: '#dbe9fd4D',
  blue_100_40: '#dbe9fd66',
  blue_100_50: '#dbe9fd80',
  blue_100_65: '#dbe9fdA5',
  blue_100_75: '#dbe9fdBF',
  blue_100_80: '#dbe9fdCC',
  blue_100_90: '#dbe9fdE6',
  blue_200: '#bddbff',
  blue_200_5: '#bddbff0D',
  blue_200_10: '#bddbff19',
  blue_200_20: '#bddbff33',
  blue_200_30: '#bddbff4D',
  blue_200_40: '#bddbff66',
  blue_200_50: '#bddbff80',
  blue_200_65: '#bddbffA5',
  blue_200_75: '#bddbffBF',
  blue_200_80: '#bddbffCC',
  blue_200_90: '#bddbffE6',
  blue_300: '#91c5ff',
  blue_300_5: '#91c5ff0D',
  blue_300_10: '#91c5ff19',
  blue_300_20: '#91c5ff33',
  blue_300_30: '#91c5ff4D',
  blue_300_40: '#91c5ff66',
  blue_300_50: '#91c5ff80',
  blue_300_65: '#91c5ffA5',
  blue_300_75: '#91c5ffBF',
  blue_300_80: '#91c5ffCC',
  blue_300_90: '#91c5ffE6',
  blue_400: '#62a4f8',
  blue_400_5: '#62a4f80D',
  blue_400_10: '#62a4f819',
  blue_400_20: '#62a4f833',
  blue_400_30: '#62a4f84D',
  blue_400_40: '#62a4f866',
  blue_400_50: '#62a4f880',
  blue_400_65: '#62a4f8A5',
  blue_400_75: '#62a4f8BF',
  blue_400_80: '#62a4f8CC',
  blue_400_90: '#62a4f8E6',
  blue_500: '#3b81f6',
  blue_500_5: '#3b81f60D',
  blue_500_10: '#3b81f619',
  blue_500_20: '#3b81f633',
  blue_500_30: '#3b81f64D',
  blue_500_40: '#3b81f666',
  blue_500_50: '#3b81f680',
  blue_500_65: '#3b81f6A5',
  blue_500_75: '#3b81f6BF',
  blue_500_80: '#3b81f6CC',
  blue_500_90: '#3b81f6E6',
  blue_600: '#2463f0',
  blue_600_5: '#2463f00D',
  blue_600_10: '#2463f019',
  blue_600_20: '#2463f033',
  blue_600_30: '#2463f04D',
  blue_600_40: '#2463f066',
  blue_600_50: '#2463f080',
  blue_600_65: '#2463f0A5',
  blue_600_75: '#2463f0BF',
  blue_600_80: '#2463f0CC',
  blue_600_90: '#2463f0E6',
  blue_700: '#1a4eda',
  blue_700_5: '#1a4eda0D',
  blue_700_10: '#1a4eda19',
  blue_700_20: '#1a4eda33',
  blue_700_30: '#1a4eda4D',
  blue_700_40: '#1a4eda66',
  blue_700_50: '#1a4eda80',
  blue_700_65: '#1a4edaA5',
  blue_700_75: '#1a4edaBF',
  blue_700_80: '#1a4edaCC',
  blue_700_90: '#1a4edaE6',
  blue_800: '#1e3fad',
  blue_800_5: '#1e3fad0D',
  blue_800_10: '#1e3fad19',
  blue_800_20: '#1e3fad33',
  blue_800_30: '#1e3fad4D',
  blue_800_40: '#1e3fad66',
  blue_800_50: '#1e3fad80',
  blue_800_65: '#1e3fadA5',
  blue_800_75: '#1e3fadBF',
  blue_800_80: '#1e3fadCC',
  blue_800_90: '#1e3fadE6',
  blue_900: '#1f3a8c',
  blue_900_5: '#1f3a8c0D',
  blue_900_10: '#1f3a8c19',
  blue_900_20: '#1f3a8c33',
  blue_900_30: '#1f3a8c4D',
  blue_900_40: '#1f3a8c66',
  blue_900_50: '#1f3a8c80',
  blue_900_65: '#1f3a8cA5',
  blue_900_75: '#1f3a8cBF',
  blue_900_80: '#1f3a8cCC',
  blue_900_90: '#1f3a8cE6',
  blue_950: '#162455',
  blue_950_5: '#1624550D',
  blue_950_10: '#16245519',
  blue_950_20: '#16245533',
  blue_950_30: '#1624554D',
  blue_950_40: '#16245566',
  blue_950_50: '#16245580',
  blue_950_65: '#162455A5',
  blue_950_75: '#162455BF',
  blue_950_80: '#162455CC',
  blue_950_90: '#162455E6',

  indigo_50: '#edf1ff',
  indigo_50_5: '#edf1ff0D',
  indigo_50_10: '#edf1ff19',
  indigo_50_20: '#edf1ff33',
  indigo_50_30: '#edf1ff4D',
  indigo_50_40: '#edf1ff66',
  indigo_50_50: '#edf1ff80',
  indigo_50_65: '#edf1ffA5',
  indigo_50_75: '#edf1ffBF',
  indigo_50_80: '#edf1ffCC',
  indigo_50_90: '#edf1ffE6',
  indigo_100: '#e1e7fd',
  indigo_100_5: '#e1e7fd0D',
  indigo_100_10: '#e1e7fd19',
  indigo_100_20: '#e1e7fd33',
  indigo_100_30: '#e1e7fd4D',
  indigo_100_40: '#e1e7fd66',
  indigo_100_50: '#e1e7fd80',
  indigo_100_65: '#e1e7fdA5',
  indigo_100_75: '#e1e7fdBF',
  indigo_100_80: '#e1e7fdCC',
  indigo_100_90: '#e1e7fdE6',
  indigo_200: '#c8d2fd',
  indigo_200_5: '#c8d2fd0D',
  indigo_200_10: '#c8d2fd19',
  indigo_200_20: '#c8d2fd33',
  indigo_200_30: '#c8d2fd4D',
  indigo_200_40: '#c8d2fd66',
  indigo_200_50: '#c8d2fd80',
  indigo_200_65: '#c8d2fdA5',
  indigo_200_75: '#c8d2fdBF',
  indigo_200_80: '#c8d2fdCC',
  indigo_200_90: '#c8d2fdE6',
  indigo_300: '#a7b5fb',
  indigo_300_5: '#a7b5fb0D',
  indigo_300_10: '#a7b5fb19',
  indigo_300_20: '#a7b5fb33',
  indigo_300_30: '#a7b5fb4D',
  indigo_300_40: '#a7b5fb66',
  indigo_300_50: '#a7b5fb80',
  indigo_300_65: '#a7b5fbA5',
  indigo_300_75: '#a7b5fbBF',
  indigo_300_80: '#a7b5fbCC',
  indigo_300_90: '#a7b5fbE6',
  indigo_400: '#818cf9',
  indigo_400_5: '#818cf90D',
  indigo_400_10: '#818cf919',
  indigo_400_20: '#818cf933',
  indigo_400_30: '#818cf94D',
  indigo_400_40: '#818cf966',
  indigo_400_50: '#818cf980',
  indigo_400_65: '#818cf9A5',
  indigo_400_75: '#818cf9BF',
  indigo_400_80: '#818cf9CC',
  indigo_400_90: '#818cf9E6',
  indigo_500: '#6469f0',
  indigo_500_5: '#6469f00D',
  indigo_500_10: '#6469f019',
  indigo_500_20: '#6469f033',
  indigo_500_30: '#6469f04D',
  indigo_500_40: '#6469f066',
  indigo_500_50: '#6469f080',
  indigo_500_65: '#6469f0A5',
  indigo_500_75: '#6469f0BF',
  indigo_500_80: '#6469f0CC',
  indigo_500_90: '#6469f0E6',
  indigo_600: '#5046e5',
  indigo_600_5: '#5046e50D',
  indigo_600_10: '#5046e519',
  indigo_600_20: '#5046e533',
  indigo_600_30: '#5046e54D',
  indigo_600_40: '#5046e566',
  indigo_600_50: '#5046e580',
  indigo_600_65: '#5046e5A5',
  indigo_600_75: '#5046e5BF',
  indigo_600_80: '#5046e5CC',
  indigo_600_90: '#5046e5E6',
  indigo_700: '#433bc9',
  indigo_700_5: '#433bc90D',
  indigo_700_10: '#433bc919',
  indigo_700_20: '#433bc933',
  indigo_700_30: '#433bc94D',
  indigo_700_40: '#433bc966',
  indigo_700_50: '#433bc980',
  indigo_700_65: '#433bc9A5',
  indigo_700_75: '#433bc9BF',
  indigo_700_80: '#433bc9CC',
  indigo_700_90: '#433bc9E6',
  indigo_800: '#3730a5',
  indigo_800_5: '#3730a50D',
  indigo_800_10: '#3730a519',
  indigo_800_20: '#3730a533',
  indigo_800_30: '#3730a54D',
  indigo_800_40: '#3730a566',
  indigo_800_50: '#3730a580',
  indigo_800_65: '#3730a5A5',
  indigo_800_75: '#3730a5BF',
  indigo_800_80: '#3730a5CC',
  indigo_800_90: '#3730a5E6',
  indigo_900: '#322d84',
  indigo_900_5: '#322d840D',
  indigo_900_10: '#322d8419',
  indigo_900_20: '#322d8433',
  indigo_900_30: '#322d844D',
  indigo_900_40: '#322d8466',
  indigo_900_50: '#322d8480',
  indigo_900_65: '#322d84A5',
  indigo_900_75: '#322d84BF',
  indigo_900_80: '#322d84CC',
  indigo_900_90: '#322d84E6',
  indigo_950: '#1f1b4e',
  indigo_950_5: '#1f1b4e0D',
  indigo_950_10: '#1f1b4e19',
  indigo_950_20: '#1f1b4e33',
  indigo_950_30: '#1f1b4e4D',
  indigo_950_40: '#1f1b4e66',
  indigo_950_50: '#1f1b4e80',
  indigo_950_65: '#1f1b4eA5',
  indigo_950_75: '#1f1b4eBF',
  indigo_950_80: '#1f1b4eCC',
  indigo_950_90: '#1f1b4eE6',

  violet_50: '#f5f3ff',
  violet_50_5: '#f5f3ff0D',
  violet_50_10: '#f5f3ff19',
  violet_50_20: '#f5f3ff33',
  violet_50_30: '#f5f3ff4D',
  violet_50_40: '#f5f3ff66',
  violet_50_50: '#f5f3ff80',
  violet_50_65: '#f5f3ffA5',
  violet_50_75: '#f5f3ffBF',
  violet_50_80: '#f5f3ffCC',
  violet_50_90: '#f5f3ffE6',
  violet_100: '#ede8fe',
  violet_100_5: '#ede8fe0D',
  violet_100_10: '#ede8fe19',
  violet_100_20: '#ede8fe33',
  violet_100_30: '#ede8fe4D',
  violet_100_40: '#ede8fe66',
  violet_100_50: '#ede8fe80',
  violet_100_65: '#ede8feA5',
  violet_100_75: '#ede8feBF',
  violet_100_80: '#ede8feCC',
  violet_100_90: '#ede8feE6',
  violet_200: '#dbd6fa',
  violet_200_5: '#dbd6fa0D',
  violet_200_10: '#dbd6fa19',
  violet_200_20: '#dbd6fa33',
  violet_200_30: '#dbd6fa4D',
  violet_200_40: '#dbd6fa66',
  violet_200_50: '#dbd6fa80',
  violet_200_65: '#dbd6faA5',
  violet_200_75: '#dbd6faBF',
  violet_200_80: '#dbd6faCC',
  violet_200_90: '#dbd6faE6',
  violet_300: '#c5b4fc',
  violet_300_5: '#c5b4fc0D',
  violet_300_10: '#c5b4fc19',
  violet_300_20: '#c5b4fc33',
  violet_300_30: '#c5b4fc4D',
  violet_300_40: '#c5b4fc66',
  violet_300_50: '#c5b4fc80',
  violet_300_65: '#c5b4fcA5',
  violet_300_75: '#c5b4fcBF',
  violet_300_80: '#c5b4fcCC',
  violet_300_90: '#c5b4fcE6',
  violet_400: '#a98bfb',
  violet_400_5: '#a98bfb0D',
  violet_400_10: '#a98bfb19',
  violet_400_20: '#a98bfb33',
  violet_400_30: '#a98bfb4D',
  violet_400_40: '#a98bfb66',
  violet_400_50: '#a98bfb80',
  violet_400_65: '#a98bfbA5',
  violet_400_75: '#a98bfbBF',
  violet_400_80: '#a98bfbCC',
  violet_400_90: '#a98bfbE6',
  violet_500: '#8d5df9',
  violet_500_5: '#8d5df90D',
  violet_500_10: '#8d5df919',
  violet_500_20: '#8d5df933',
  violet_500_30: '#8d5df94D',
  violet_500_40: '#8d5df966',
  violet_500_50: '#8d5df980',
  violet_500_65: '#8d5df9A5',
  violet_500_75: '#8d5df9BF',
  violet_500_80: '#8d5df9CC',
  violet_500_90: '#8d5df9E6',
  violet_600: '#7d38ef',
  violet_600_5: '#7d38ef0D',
  violet_600_10: '#7d38ef19',
  violet_600_20: '#7d38ef33',
  violet_600_30: '#7d38ef4D',
  violet_600_40: '#7d38ef66',
  violet_600_50: '#7d38ef80',
  violet_600_65: '#7d38efA5',
  violet_600_75: '#7d38efBF',
  violet_600_80: '#7d38efCC',
  violet_600_90: '#7d38efE6',
  violet_700: '#6d29d8',
  violet_700_5: '#6d29d80D',
  violet_700_10: '#6d29d819',
  violet_700_20: '#6d29d833',
  violet_700_30: '#6d29d84D',
  violet_700_40: '#6d29d866',
  violet_700_50: '#6d29d880',
  violet_700_65: '#6d29d8A5',
  violet_700_75: '#6d29d8BF',
  violet_700_80: '#6d29d8CC',
  violet_700_90: '#6d29d8E6',
  violet_800: '#5b20b5',
  violet_800_5: '#5b20b50D',
  violet_800_10: '#5b20b519',
  violet_800_20: '#5b20b533',
  violet_800_30: '#5b20b54D',
  violet_800_40: '#5b20b566',
  violet_800_50: '#5b20b580',
  violet_800_65: '#5b20b5A5',
  violet_800_75: '#5b20b5BF',
  violet_800_80: '#5b20b5CC',
  violet_800_90: '#5b20b5E6',
  violet_900: '#4d1c96',
  violet_900_5: '#4d1c960D',
  violet_900_10: '#4d1c9619',
  violet_900_20: '#4d1c9633',
  violet_900_30: '#4d1c964D',
  violet_900_40: '#4d1c9666',
  violet_900_50: '#4d1c9680',
  violet_900_65: '#4d1c96A5',
  violet_900_75: '#4d1c96BF',
  violet_900_80: '#4d1c96CC',
  violet_900_90: '#4d1c96E6',
  violet_950: '#2e0c66',
  violet_950_5: '#2e0c660D',
  violet_950_10: '#2e0c6619',
  violet_950_20: '#2e0c6633',
  violet_950_30: '#2e0c664D',
  violet_950_40: '#2e0c6666',
  violet_950_50: '#2e0c6680',
  violet_950_65: '#2e0c66A5',
  violet_950_75: '#2e0c66BF',
  violet_950_80: '#2e0c66CC',
  violet_950_90: '#2e0c66E6',

  purple_50: '#fbf7fe',
  purple_50_5: '#fbf7fe0D',
  purple_50_10: '#fbf7fe19',
  purple_50_20: '#fbf7fe33',
  purple_50_30: '#fbf7fe4D',
  purple_50_40: '#fbf7fe66',
  purple_50_50: '#fbf7fe80',
  purple_50_65: '#fbf7feA5',
  purple_50_75: '#fbf7feBF',
  purple_50_80: '#fbf7feCC',
  purple_50_90: '#fbf7feE6',
  purple_100: '#f4eaff',
  purple_100_5: '#f4eaff0D',
  purple_100_10: '#f4eaff19',
  purple_100_20: '#f4eaff33',
  purple_100_30: '#f4eaff4D',
  purple_100_40: '#f4eaff66',
  purple_100_50: '#f4eaff80',
  purple_100_65: '#f4eaffA5',
  purple_100_75: '#f4eaffBF',
  purple_100_80: '#f4eaffCC',
  purple_100_90: '#f4eaffE6',
  purple_200: '#e8d4fe',
  purple_200_5: '#e8d4fe0D',
  purple_200_10: '#e8d4fe19',
  purple_200_20: '#e8d4fe33',
  purple_200_30: '#e8d4fe4D',
  purple_200_40: '#e8d4fe66',
  purple_200_50: '#e8d4fe80',
  purple_200_65: '#e8d4feA5',
  purple_200_75: '#e8d4feBF',
  purple_200_80: '#e8d4feCC',
  purple_200_90: '#e8d4feE6',
  purple_300: '#d9b5ff',
  purple_300_5: '#d9b5ff0D',
  purple_300_10: '#d9b5ff19',
  purple_300_20: '#d9b5ff33',
  purple_300_30: '#d9b5ff4D',
  purple_300_40: '#d9b5ff66',
  purple_300_50: '#d9b5ff80',
  purple_300_65: '#d9b5ffA5',
  purple_300_75: '#d9b5ffBF',
  purple_300_80: '#d9b5ffCC',
  purple_300_90: '#d9b5ffE6',
  purple_400: '#c182fc',
  purple_400_5: '#c182fc0D',
  purple_400_10: '#c182fc19',
  purple_400_20: '#c182fc33',
  purple_400_30: '#c182fc4D',
  purple_400_40: '#c182fc66',
  purple_400_50: '#c182fc80',
  purple_400_65: '#c182fcA5',
  purple_400_75: '#c182fcBF',
  purple_400_80: '#c182fcCC',
  purple_400_90: '#c182fcE6',
  purple_500: '#a957f7',
  purple_500_5: '#a957f70D',
  purple_500_10: '#a957f719',
  purple_500_20: '#a957f733',
  purple_500_30: '#a957f74D',
  purple_500_40: '#a957f766',
  purple_500_50: '#a957f780',
  purple_500_65: '#a957f7A5',
  purple_500_75: '#a957f7BF',
  purple_500_80: '#a957f7CC',
  purple_500_90: '#a957f7E6',
  purple_600: '#9336eb',
  purple_600_5: '#9336eb0D',
  purple_600_10: '#9336eb19',
  purple_600_20: '#9336eb33',
  purple_600_30: '#9336eb4D',
  purple_600_40: '#9336eb66',
  purple_600_50: '#9336eb80',
  purple_600_65: '#9336ebA5',
  purple_600_75: '#9336ebBF',
  purple_600_80: '#9336ebCC',
  purple_600_90: '#9336ebE6',
  purple_700: '#8021d1',
  purple_700_5: '#8021d10D',
  purple_700_10: '#8021d119',
  purple_700_20: '#8021d133',
  purple_700_30: '#8021d14D',
  purple_700_40: '#8021d166',
  purple_700_50: '#8021d180',
  purple_700_65: '#8021d1A5',
  purple_700_75: '#8021d1BF',
  purple_700_80: '#8021d1CC',
  purple_700_90: '#8021d1E6',
  purple_800: '#6d21a9',
  purple_800_5: '#6d21a90D',
  purple_800_10: '#6d21a919',
  purple_800_20: '#6d21a933',
  purple_800_30: '#6d21a94D',
  purple_800_40: '#6d21a966',
  purple_800_50: '#6d21a980',
  purple_800_65: '#6d21a9A5',
  purple_800_75: '#6d21a9BF',
  purple_800_80: '#6d21a9CC',
  purple_800_90: '#6d21a9E6',
  purple_900: '#581a88',
  purple_900_5: '#581a880D',
  purple_900_10: '#581a8819',
  purple_900_20: '#581a8833',
  purple_900_30: '#581a884D',
  purple_900_40: '#581a8866',
  purple_900_50: '#581a8880',
  purple_900_65: '#581a88A5',
  purple_900_75: '#581a88BF',
  purple_900_80: '#581a88CC',
  purple_900_90: '#581a88E6',
  purple_950: '#3b0963',
  purple_950_5: '#3b09630D',
  purple_950_10: '#3b096319',
  purple_950_20: '#3b096333',
  purple_950_30: '#3b09634D',
  purple_950_40: '#3b096366',
  purple_950_50: '#3b096380',
  purple_950_65: '#3b0963A5',
  purple_950_75: '#3b0963BF',
  purple_950_80: '#3b0963CC',
  purple_950_90: '#3b0963E6',

  fuchsia_50: '#fff5ff',
  fuchsia_50_5: '#fff5ff0D',
  fuchsia_50_10: '#fff5ff19',
  fuchsia_50_20: '#fff5ff33',
  fuchsia_50_30: '#fff5ff4D',
  fuchsia_50_40: '#fff5ff66',
  fuchsia_50_50: '#fff5ff80',
  fuchsia_50_65: '#fff5ffA5',
  fuchsia_50_75: '#fff5ffBF',
  fuchsia_50_80: '#fff5ffCC',
  fuchsia_50_90: '#fff5ffE6',
  fuchsia_100: '#fae6ff',
  fuchsia_100_5: '#fae6ff0D',
  fuchsia_100_10: '#fae6ff19',
  fuchsia_100_20: '#fae6ff33',
  fuchsia_100_30: '#fae6ff4D',
  fuchsia_100_40: '#fae6ff66',
  fuchsia_100_50: '#fae6ff80',
  fuchsia_100_65: '#fae6ffA5',
  fuchsia_100_75: '#fae6ffBF',
  fuchsia_100_80: '#fae6ffCC',
  fuchsia_100_90: '#fae6ffE6',
  fuchsia_200: '#f4d0fc',
  fuchsia_200_5: '#f4d0fc0D',
  fuchsia_200_10: '#f4d0fc19',
  fuchsia_200_20: '#f4d0fc33',
  fuchsia_200_30: '#f4d0fc4D',
  fuchsia_200_40: '#f4d0fc66',
  fuchsia_200_50: '#f4d0fc80',
  fuchsia_200_65: '#f4d0fcA5',
  fuchsia_200_75: '#f4d0fcBF',
  fuchsia_200_80: '#f4d0fcCC',
  fuchsia_200_90: '#f4d0fcE6',
  fuchsia_300: '#eeabfb',
  fuchsia_300_5: '#eeabfb0D',
  fuchsia_300_10: '#eeabfb19',
  fuchsia_300_20: '#eeabfb33',
  fuchsia_300_30: '#eeabfb4D',
  fuchsia_300_40: '#eeabfb66',
  fuchsia_300_50: '#eeabfb80',
  fuchsia_300_65: '#eeabfbA5',
  fuchsia_300_75: '#eeabfbBF',
  fuchsia_300_80: '#eeabfbCC',
  fuchsia_300_90: '#eeabfbE6',
  fuchsia_400: '#ea79fc',
  fuchsia_400_5: '#ea79fc0D',
  fuchsia_400_10: '#ea79fc19',
  fuchsia_400_20: '#ea79fc33',
  fuchsia_400_30: '#ea79fc4D',
  fuchsia_400_40: '#ea79fc66',
  fuchsia_400_50: '#ea79fc80',
  fuchsia_400_65: '#ea79fcA5',
  fuchsia_400_75: '#ea79fcBF',
  fuchsia_400_80: '#ea79fcCC',
  fuchsia_400_90: '#ea79fcE6',
  fuchsia_500: '#da47f1',
  fuchsia_500_5: '#da47f10D',
  fuchsia_500_10: '#da47f119',
  fuchsia_500_20: '#da47f133',
  fuchsia_500_30: '#da47f14D',
  fuchsia_500_40: '#da47f166',
  fuchsia_500_50: '#da47f180',
  fuchsia_500_65: '#da47f1A5',
  fuchsia_500_75: '#da47f1BF',
  fuchsia_500_80: '#da47f1CC',
  fuchsia_500_90: '#da47f1E6',
  fuchsia_600: '#c122d3',
  fuchsia_600_5: '#c122d30D',
  fuchsia_600_10: '#c122d319',
  fuchsia_600_20: '#c122d333',
  fuchsia_600_30: '#c122d34D',
  fuchsia_600_40: '#c122d366',
  fuchsia_600_50: '#c122d380',
  fuchsia_600_65: '#c122d3A5',
  fuchsia_600_75: '#c122d3BF',
  fuchsia_600_80: '#c122d3CC',
  fuchsia_600_90: '#c122d3E6',
  fuchsia_700: '#a418b1',
  fuchsia_700_5: '#a418b10D',
  fuchsia_700_10: '#a418b119',
  fuchsia_700_20: '#a418b133',
  fuchsia_700_30: '#a418b14D',
  fuchsia_700_40: '#a418b166',
  fuchsia_700_50: '#a418b180',
  fuchsia_700_65: '#a418b1A5',
  fuchsia_700_75: '#a418b1BF',
  fuchsia_700_80: '#a418b1CC',
  fuchsia_700_90: '#a418b1E6',
  fuchsia_800: '#861a8e',
  fuchsia_800_5: '#861a8e0D',
  fuchsia_800_10: '#861a8e19',
  fuchsia_800_20: '#861a8e33',
  fuchsia_800_30: '#861a8e4D',
  fuchsia_800_40: '#861a8e66',
  fuchsia_800_50: '#861a8e80',
  fuchsia_800_65: '#861a8eA5',
  fuchsia_800_75: '#861a8eBF',
  fuchsia_800_80: '#861a8eCC',
  fuchsia_800_90: '#861a8eE6',
  fuchsia_900: '#701a75',
  fuchsia_900_5: '#701a750D',
  fuchsia_900_10: '#701a7519',
  fuchsia_900_20: '#701a7533',
  fuchsia_900_30: '#701a754D',
  fuchsia_900_40: '#701a7566',
  fuchsia_900_50: '#701a7580',
  fuchsia_900_65: '#701a75A5',
  fuchsia_900_75: '#701a75BF',
  fuchsia_900_80: '#701a75CC',
  fuchsia_900_90: '#701a75E6',
  fuchsia_950: '#4a034d',
  fuchsia_950_5: '#4a034d0D',
  fuchsia_950_10: '#4a034d19',
  fuchsia_950_20: '#4a034d33',
  fuchsia_950_30: '#4a034d4D',
  fuchsia_950_40: '#4a034d66',
  fuchsia_950_50: '#4a034d80',
  fuchsia_950_65: '#4a034dA5',
  fuchsia_950_75: '#4a034dBF',
  fuchsia_950_80: '#4a034dCC',
  fuchsia_950_90: '#4a034dE6',

  pink_50: '#faf3f7',
  pink_50_5: '#faf3f70D',
  pink_50_10: '#faf3f719',
  pink_50_20: '#faf3f733',
  pink_50_30: '#faf3f74D',
  pink_50_40: '#faf3f766',
  pink_50_50: '#faf3f780',
  pink_50_65: '#faf3f7A5',
  pink_50_75: '#faf3f7BF',
  pink_50_80: '#faf3f7CC',
  pink_50_90: '#faf3f7E6',
  pink_100: '#fee7f5',
  pink_100_5: '#fee7f50D',
  pink_100_10: '#fee7f519',
  pink_100_20: '#fee7f533',
  pink_100_30: '#fee7f54D',
  pink_100_40: '#fee7f566',
  pink_100_50: '#fee7f580',
  pink_100_65: '#fee7f5A5',
  pink_100_75: '#fee7f5BF',
  pink_100_80: '#fee7f5CC',
  pink_100_90: '#fee7f5E6',
  pink_200: '#fccfe8',
  pink_200_5: '#fccfe80D',
  pink_200_10: '#fccfe819',
  pink_200_20: '#fccfe833',
  pink_200_30: '#fccfe84D',
  pink_200_40: '#fccfe866',
  pink_200_50: '#fccfe880',
  pink_200_65: '#fccfe8A5',
  pink_200_75: '#fccfe8BF',
  pink_200_80: '#fccfe8CC',
  pink_200_90: '#fccfe8E6',
  pink_300: '#f9a7d3',
  pink_300_5: '#f9a7d30D',
  pink_300_10: '#f9a7d319',
  pink_300_20: '#f9a7d333',
  pink_300_30: '#f9a7d34D',
  pink_300_40: '#f9a7d366',
  pink_300_50: '#f9a7d380',
  pink_300_65: '#f9a7d3A5',
  pink_300_75: '#f9a7d3BF',
  pink_300_80: '#f9a7d3CC',
  pink_300_90: '#f9a7d3E6',
  pink_400: '#f872b8',
  pink_400_5: '#f872b80D',
  pink_400_10: '#f872b819',
  pink_400_20: '#f872b833',
  pink_400_30: '#f872b84D',
  pink_400_40: '#f872b866',
  pink_400_50: '#f872b880',
  pink_400_65: '#f872b8A5',
  pink_400_75: '#f872b8BF',
  pink_400_80: '#f872b8CC',
  pink_400_90: '#f872b8E6',
  pink_500: '#ed4b9b',
  pink_500_5: '#ed4b9b0D',
  pink_500_10: '#ed4b9b19',
  pink_500_20: '#ed4b9b33',
  pink_500_30: '#ed4b9b4D',
  pink_500_40: '#ed4b9b66',
  pink_500_50: '#ed4b9b80',
  pink_500_65: '#ed4b9bA5',
  pink_500_75: '#ed4b9bBF',
  pink_500_80: '#ed4b9bCC',
  pink_500_90: '#ed4b9bE6',
  pink_600: '#dc2476',
  pink_600_5: '#dc24760D',
  pink_600_10: '#dc247619',
  pink_600_20: '#dc247633',
  pink_600_30: '#dc24764D',
  pink_600_40: '#dc247666',
  pink_600_50: '#dc247680',
  pink_600_65: '#dc2476A5',
  pink_600_75: '#dc2476BF',
  pink_600_80: '#dc2476CC',
  pink_600_90: '#dc2476E6',
  pink_700: '#bd135c',
  pink_700_5: '#bd135c0D',
  pink_700_10: '#bd135c19',
  pink_700_20: '#bd135c33',
  pink_700_30: '#bd135c4D',
  pink_700_40: '#bd135c66',
  pink_700_50: '#bd135c80',
  pink_700_65: '#bd135cA5',
  pink_700_75: '#bd135cBF',
  pink_700_80: '#bd135cCC',
  pink_700_90: '#bd135cE6',
  pink_800: '#9e164d',
  pink_800_5: '#9e164d0D',
  pink_800_10: '#9e164d19',
  pink_800_20: '#9e164d33',
  pink_800_30: '#9e164d4D',
  pink_800_40: '#9e164d66',
  pink_800_50: '#9e164d80',
  pink_800_65: '#9e164dA5',
  pink_800_75: '#9e164dBF',
  pink_800_80: '#9e164dCC',
  pink_800_90: '#9e164dE6',
  pink_900: '#831c44',
  pink_900_5: '#831c440D',
  pink_900_10: '#831c4419',
  pink_900_20: '#831c4433',
  pink_900_30: '#831c444D',
  pink_900_40: '#831c4466',
  pink_900_50: '#831c4480',
  pink_900_65: '#831c44A5',
  pink_900_75: '#831c44BF',
  pink_900_80: '#831c44CC',
  pink_900_90: '#831c44E6',
  pink_950: '#4e0823',
  pink_950_5: '#4e08230D',
  pink_950_10: '#4e082319',
  pink_950_20: '#4e082333',
  pink_950_30: '#4e08234D',
  pink_950_40: '#4e082366',
  pink_950_50: '#4e082380',
  pink_950_65: '#4e0823A5',
  pink_950_75: '#4e0823BF',
  pink_950_80: '#4e0823CC',
  pink_950_90: '#4e0823E6',

  rose_50: '#fff0f2',
  rose_50_5: '#fff0f20D',
  rose_50_10: '#fff0f219',
  rose_50_20: '#fff0f233',
  rose_50_30: '#fff0f24D',
  rose_50_40: '#fff0f266',
  rose_50_50: '#fff0f280',
  rose_50_65: '#fff0f2A5',
  rose_50_75: '#fff0f2BF',
  rose_50_80: '#fff0f2CC',
  rose_50_90: '#fff0f2E6',
  rose_100: '#fee4e6',
  rose_100_5: '#fee4e60D',
  rose_100_10: '#fee4e619',
  rose_100_20: '#fee4e633',
  rose_100_30: '#fee4e64D',
  rose_100_40: '#fee4e666',
  rose_100_50: '#fee4e680',
  rose_100_65: '#fee4e6A5',
  rose_100_75: '#fee4e6BF',
  rose_100_80: '#fee4e6CC',
  rose_100_90: '#fee4e6E6',
  rose_200: '#ffcbd2',
  rose_200_5: '#ffcbd20D',
  rose_200_10: '#ffcbd219',
  rose_200_20: '#ffcbd233',
  rose_200_30: '#ffcbd24D',
  rose_200_40: '#ffcbd266',
  rose_200_50: '#ffcbd280',
  rose_200_65: '#ffcbd2A5',
  rose_200_75: '#ffcbd2BF',
  rose_200_80: '#ffcbd2CC',
  rose_200_90: '#ffcbd2E6',
  rose_300: '#ffa3ae',
  rose_300_5: '#ffa3ae0D',
  rose_300_10: '#ffa3ae19',
  rose_300_20: '#ffa3ae33',
  rose_300_30: '#ffa3ae4D',
  rose_300_40: '#ffa3ae66',
  rose_300_50: '#ffa3ae80',
  rose_300_65: '#ffa3aeA5',
  rose_300_75: '#ffa3aeBF',
  rose_300_80: '#ffa3aeCC',
  rose_300_90: '#ffa3aeE6',
  rose_400: '#fc7186',
  rose_400_5: '#fc71860D',
  rose_400_10: '#fc718619',
  rose_400_20: '#fc718633',
  rose_400_30: '#fc71864D',
  rose_400_40: '#fc718666',
  rose_400_50: '#fc718680',
  rose_400_65: '#fc7186A5',
  rose_400_75: '#fc7186BF',
  rose_400_80: '#fc7186CC',
  rose_400_90: '#fc7186E6',
  rose_500: '#f73e5f',
  rose_500_5: '#f73e5f0D',
  rose_500_10: '#f73e5f19',
  rose_500_20: '#f73e5f33',
  rose_500_30: '#f73e5f4D',
  rose_500_40: '#f73e5f66',
  rose_500_50: '#f73e5f80',
  rose_500_65: '#f73e5fA5',
  rose_500_75: '#f73e5fBF',
  rose_500_80: '#f73e5fCC',
  rose_500_90: '#f73e5fE6',
  rose_600: '#e22249',
  rose_600_5: '#e222490D',
  rose_600_10: '#e2224919',
  rose_600_20: '#e2224933',
  rose_600_30: '#e222494D',
  rose_600_40: '#e2224966',
  rose_600_50: '#e2224980',
  rose_600_65: '#e22249A5',
  rose_600_75: '#e22249BF',
  rose_600_80: '#e22249CC',
  rose_600_90: '#e22249E6',
  rose_700: '#be0b3a',
  rose_700_5: '#be0b3a0D',
  rose_700_10: '#be0b3a19',
  rose_700_20: '#be0b3a33',
  rose_700_30: '#be0b3a4D',
  rose_700_40: '#be0b3a66',
  rose_700_50: '#be0b3a80',
  rose_700_65: '#be0b3aA5',
  rose_700_75: '#be0b3aBF',
  rose_700_80: '#be0b3aCC',
  rose_700_90: '#be0b3aE6',
  rose_800: '#9d1138',
  rose_800_5: '#9d11380D',
  rose_800_10: '#9d113819',
  rose_800_20: '#9d113833',
  rose_800_30: '#9d11384D',
  rose_800_40: '#9d113866',
  rose_800_50: '#9d113880',
  rose_800_65: '#9d1138A5',
  rose_800_75: '#9d1138BF',
  rose_800_80: '#9d1138CC',
  rose_800_90: '#9d1138E6',
  rose_900: '#881337',
  rose_900_5: '#8813370D',
  rose_900_10: '#88133719',
  rose_900_20: '#88133733',
  rose_900_30: '#8813374D',
  rose_900_40: '#88133766',
  rose_900_50: '#88133780',
  rose_900_65: '#881337A5',
  rose_900_75: '#881337BF',
  rose_900_80: '#881337CC',
  rose_900_90: '#881337E6',
  rose_950: '#4c0419',
  rose_950_5: '#4c04190D',
  rose_950_10: '#4c041919',
  rose_950_20: '#4c041933',
  rose_950_30: '#4c04194D',
  rose_950_40: '#4c041966',
  rose_950_50: '#4c041980',
  rose_950_65: '#4c0419A5',
  rose_950_75: '#4c0419BF',
  rose_950_80: '#4c0419CC',
  rose_950_90: '#4c0419E6',
}
